var wc = Object.defineProperty;
var i = (e, t) => wc(e, "name", { value: t, configurable: !0 });
var _ = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports);

// ../node_modules/has-symbols/shams.js
var Sr = _((Yy, no) => {
  "use strict";
  no.exports = /* @__PURE__ */ i(function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, r = Symbol("test"), n = Object(r);
    if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Sy\
mbol]")
      return !1;
    var o = 42;
    t[r] = o;
    for (var s in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(
    t).length !== 0)
      return !1;
    var c = Object.getOwnPropertySymbols(t);
    if (c.length !== 1 || c[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var u = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, r)
      );
      if (u.value !== o || u.enumerable !== !0)
        return !1;
    }
    return !0;
  }, "hasSymbols");
});

// ../node_modules/has-tostringtag/shams.js
var mt = _((Vy, oo) => {
  "use strict";
  var nu = Sr();
  oo.exports = /* @__PURE__ */ i(function() {
    return nu() && !!Symbol.toStringTag;
  }, "hasToStringTagShams");
});

// ../node_modules/es-object-atoms/index.js
var Er = _((Ky, io) => {
  "use strict";
  io.exports = Object;
});

// ../node_modules/es-errors/index.js
var co = _((Jy, so) => {
  "use strict";
  so.exports = Error;
});

// ../node_modules/es-errors/eval.js
var uo = _((Xy, ao) => {
  "use strict";
  ao.exports = EvalError;
});

// ../node_modules/es-errors/range.js
var fo = _((Zy, lo) => {
  "use strict";
  lo.exports = RangeError;
});

// ../node_modules/es-errors/ref.js
var yo = _((Qy, po) => {
  "use strict";
  po.exports = ReferenceError;
});

// ../node_modules/es-errors/syntax.js
var Ar = _((eg, go) => {
  "use strict";
  go.exports = SyntaxError;
});

// ../node_modules/es-errors/type.js
var We = _((tg, mo) => {
  "use strict";
  mo.exports = TypeError;
});

// ../node_modules/es-errors/uri.js
var bo = _((rg, ho) => {
  "use strict";
  ho.exports = URIError;
});

// ../node_modules/math-intrinsics/abs.js
var Eo = _((ng, So) => {
  "use strict";
  So.exports = Math.abs;
});

// ../node_modules/math-intrinsics/floor.js
var Oo = _((og, Ao) => {
  "use strict";
  Ao.exports = Math.floor;
});

// ../node_modules/math-intrinsics/max.js
var wo = _((ig, _o) => {
  "use strict";
  _o.exports = Math.max;
});

// ../node_modules/math-intrinsics/min.js
var Po = _((sg, To) => {
  "use strict";
  To.exports = Math.min;
});

// ../node_modules/math-intrinsics/pow.js
var $o = _((cg, Co) => {
  "use strict";
  Co.exports = Math.pow;
});

// ../node_modules/math-intrinsics/round.js
var Io = _((ag, Ro) => {
  "use strict";
  Ro.exports = Math.round;
});

// ../node_modules/math-intrinsics/isNaN.js
var jo = _((ug, No) => {
  "use strict";
  No.exports = Number.isNaN || /* @__PURE__ */ i(function(t) {
    return t !== t;
  }, "isNaN");
});

// ../node_modules/math-intrinsics/sign.js
var xo = _((fg, Mo) => {
  "use strict";
  var ou = jo();
  Mo.exports = /* @__PURE__ */ i(function(t) {
    return ou(t) || t === 0 ? t : t < 0 ? -1 : 1;
  }, "sign");
});

// ../node_modules/gopd/gOPD.js
var Fo = _((yg, vo) => {
  "use strict";
  vo.exports = Object.getOwnPropertyDescriptor;
});

// ../node_modules/gopd/index.js
var Ce = _((gg, Lo) => {
  "use strict";
  var ht = Fo();
  if (ht)
    try {
      ht([], "length");
    } catch {
      ht = null;
    }
  Lo.exports = ht;
});

// ../node_modules/es-define-property/index.js
var Ye = _((mg, Do) => {
  "use strict";
  var dt = Object.defineProperty || !1;
  if (dt)
    try {
      dt({}, "a", { value: 1 });
    } catch {
      dt = !1;
    }
  Do.exports = dt;
});

// ../node_modules/has-symbols/index.js
var Uo = _((hg, ko) => {
  "use strict";
  var Bo = typeof Symbol < "u" && Symbol, iu = Sr();
  ko.exports = /* @__PURE__ */ i(function() {
    return typeof Bo != "function" || typeof Symbol != "function" || typeof Bo("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 :
    iu();
  }, "hasNativeSymbols");
});

// ../node_modules/get-proto/Reflect.getPrototypeOf.js
var Or = _((bg, qo) => {
  "use strict";
  qo.exports = typeof Reflect < "u" && Reflect.getPrototypeOf || null;
});

// ../node_modules/get-proto/Object.getPrototypeOf.js
var _r = _((Sg, zo) => {
  "use strict";
  var su = Er();
  zo.exports = su.getPrototypeOf || null;
});

// ../node_modules/function-bind/implementation.js
var Go = _((Eg, Yo) => {
  "use strict";
  var cu = "Function.prototype.bind called on incompatible ", au = Object.prototype.toString, uu = Math.max, lu = "[object Function]", Wo = /* @__PURE__ */ i(
  function(t, r) {
    for (var n = [], o = 0; o < t.length; o += 1)
      n[o] = t[o];
    for (var s = 0; s < r.length; s += 1)
      n[s + t.length] = r[s];
    return n;
  }, "concatty"), fu = /* @__PURE__ */ i(function(t, r) {
    for (var n = [], o = r || 0, s = 0; o < t.length; o += 1, s += 1)
      n[s] = t[o];
    return n;
  }, "slicy"), pu = /* @__PURE__ */ i(function(e, t) {
    for (var r = "", n = 0; n < e.length; n += 1)
      r += e[n], n + 1 < e.length && (r += t);
    return r;
  }, "joiny");
  Yo.exports = /* @__PURE__ */ i(function(t) {
    var r = this;
    if (typeof r != "function" || au.apply(r) !== lu)
      throw new TypeError(cu + r);
    for (var n = fu(arguments, 1), o, s = /* @__PURE__ */ i(function() {
      if (this instanceof o) {
        var y = r.apply(
          this,
          Wo(n, arguments)
        );
        return Object(y) === y ? y : this;
      }
      return r.apply(
        t,
        Wo(n, arguments)
      );
    }, "binder"), c = uu(0, r.length - n.length), u = [], a = 0; a < c; a++)
      u[a] = "$" + a;
    if (o = Function("binder", "return function (" + pu(u, ",") + "){ return binder.apply(this,arguments); }")(s), r.prototype) {
      var f = /* @__PURE__ */ i(function() {
      }, "Empty");
      f.prototype = r.prototype, o.prototype = new f(), f.prototype = null;
    }
    return o;
  }, "bind");
});

// ../node_modules/function-bind/index.js
var $e = _((Og, Vo) => {
  "use strict";
  var yu = Go();
  Vo.exports = Function.prototype.bind || yu;
});

// ../node_modules/call-bind-apply-helpers/functionCall.js
var bt = _((_g, Ho) => {
  "use strict";
  Ho.exports = Function.prototype.call;
});

// ../node_modules/call-bind-apply-helpers/functionApply.js
var St = _((wg, Ko) => {
  "use strict";
  Ko.exports = Function.prototype.apply;
});

// ../node_modules/call-bind-apply-helpers/reflectApply.js
var Xo = _((Tg, Jo) => {
  "use strict";
  Jo.exports = typeof Reflect < "u" && Reflect && Reflect.apply;
});

// ../node_modules/call-bind-apply-helpers/actualApply.js
var wr = _((Pg, Zo) => {
  "use strict";
  var gu = $e(), mu = St(), hu = bt(), du = Xo();
  Zo.exports = du || gu.call(hu, mu);
});

// ../node_modules/call-bind-apply-helpers/index.js
var Et = _((Cg, Qo) => {
  "use strict";
  var bu = $e(), Su = We(), Eu = bt(), Au = wr();
  Qo.exports = /* @__PURE__ */ i(function(t) {
    if (t.length < 1 || typeof t[0] != "function")
      throw new Su("a function is required");
    return Au(bu, Eu, t);
  }, "callBindBasic");
});

// ../node_modules/dunder-proto/get.js
var ii = _((Rg, oi) => {
  "use strict";
  var Ou = Et(), ei = Ce(), ri;
  try {
    ri = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (e) {
    if (!e || typeof e != "object" || !("code" in e) || e.code !== "ERR_PROTO_ACCESS")
      throw e;
  }
  var Tr = !!ri && ei && ei(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), ni = Object, ti = ni.getPrototypeOf;
  oi.exports = Tr && typeof Tr.get == "function" ? Ou([Tr.get]) : typeof ti == "function" ? (
    /** @type {import('./get')} */
    /* @__PURE__ */ i(function(t) {
      return ti(t == null ? t : ni(t));
    }, "getDunder")
  ) : !1;
});

// ../node_modules/get-proto/index.js
var li = _((Ng, ui) => {
  "use strict";
  var si = Or(), ci = _r(), ai = ii();
  ui.exports = si ? /* @__PURE__ */ i(function(t) {
    return si(t);
  }, "getProto") : ci ? /* @__PURE__ */ i(function(t) {
    if (!t || typeof t != "object" && typeof t != "function")
      throw new TypeError("getProto: not an object");
    return ci(t);
  }, "getProto") : ai ? /* @__PURE__ */ i(function(t) {
    return ai(t);
  }, "getProto") : null;
});

// ../node_modules/hasown/index.js
var pi = _((Mg, fi) => {
  "use strict";
  var _u = Function.prototype.call, wu = Object.prototype.hasOwnProperty, Tu = $e();
  fi.exports = Tu.call(_u, wu);
});

// ../node_modules/get-intrinsic/index.js
var _t = _((xg, bi) => {
  "use strict";
  var R, Pu = Er(), Cu = co(), $u = uo(), Ru = fo(), Iu = yo(), je = Ar(), Ne = We(), Nu = bo(), ju = Eo(), Mu = Oo(), xu = wo(), vu = Po(),
  Fu = $o(), Lu = Io(), Du = xo(), hi = Function, Pr = /* @__PURE__ */ i(function(e) {
    try {
      return hi('"use strict"; return (' + e + ").constructor;")();
    } catch {
    }
  }, "getEvalledConstructor"), Ge = Ce(), Bu = Ye(), Cr = /* @__PURE__ */ i(function() {
    throw new Ne();
  }, "throwTypeError"), ku = Ge ? function() {
    try {
      return arguments.callee, Cr;
    } catch {
      try {
        return Ge(arguments, "callee").get;
      } catch {
        return Cr;
      }
    }
  }() : Cr, Re = Uo()(), U = li(), Uu = _r(), qu = Or(), di = St(), Ve = bt(), Ie = {}, zu = typeof Uint8Array > "u" || !U ? R : U(Uint8Array),
  Ee = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? R : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? R : ArrayBuffer,
    "%ArrayIteratorPrototype%": Re && U ? U([][Symbol.iterator]()) : R,
    "%AsyncFromSyncIteratorPrototype%": R,
    "%AsyncFunction%": Ie,
    "%AsyncGenerator%": Ie,
    "%AsyncGeneratorFunction%": Ie,
    "%AsyncIteratorPrototype%": Ie,
    "%Atomics%": typeof Atomics > "u" ? R : Atomics,
    "%BigInt%": typeof BigInt > "u" ? R : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? R : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? R : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? R : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Cu,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": $u,
    "%Float32Array%": typeof Float32Array > "u" ? R : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? R : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? R : FinalizationRegistry,
    "%Function%": hi,
    "%GeneratorFunction%": Ie,
    "%Int8Array%": typeof Int8Array > "u" ? R : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? R : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? R : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": Re && U ? U(U([][Symbol.iterator]())) : R,
    "%JSON%": typeof JSON == "object" ? JSON : R,
    "%Map%": typeof Map > "u" ? R : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !Re || !U ? R : U((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Pu,
    "%Object.getOwnPropertyDescriptor%": Ge,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? R : Promise,
    "%Proxy%": typeof Proxy > "u" ? R : Proxy,
    "%RangeError%": Ru,
    "%ReferenceError%": Iu,
    "%Reflect%": typeof Reflect > "u" ? R : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? R : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !Re || !U ? R : U((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? R : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": Re && U ? U(""[Symbol.iterator]()) : R,
    "%Symbol%": Re ? Symbol : R,
    "%SyntaxError%": je,
    "%ThrowTypeError%": ku,
    "%TypedArray%": zu,
    "%TypeError%": Ne,
    "%Uint8Array%": typeof Uint8Array > "u" ? R : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? R : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? R : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? R : Uint32Array,
    "%URIError%": Nu,
    "%WeakMap%": typeof WeakMap > "u" ? R : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? R : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? R : WeakSet,
    "%Function.prototype.call%": Ve,
    "%Function.prototype.apply%": di,
    "%Object.defineProperty%": Bu,
    "%Object.getPrototypeOf%": Uu,
    "%Math.abs%": ju,
    "%Math.floor%": Mu,
    "%Math.max%": xu,
    "%Math.min%": vu,
    "%Math.pow%": Fu,
    "%Math.round%": Lu,
    "%Math.sign%": Du,
    "%Reflect.getPrototypeOf%": qu
  };
  if (U)
    try {
      null.error;
    } catch (e) {
      yi = U(U(e)), Ee["%Error.prototype%"] = yi;
    }
  var yi, Wu = /* @__PURE__ */ i(function e(t) {
    var r;
    if (t === "%AsyncFunction%")
      r = Pr("async function () {}");
    else if (t === "%GeneratorFunction%")
      r = Pr("function* () {}");
    else if (t === "%AsyncGeneratorFunction%")
      r = Pr("async function* () {}");
    else if (t === "%AsyncGenerator%") {
      var n = e("%AsyncGeneratorFunction%");
      n && (r = n.prototype);
    } else if (t === "%AsyncIteratorPrototype%") {
      var o = e("%AsyncGenerator%");
      o && U && (r = U(o.prototype));
    }
    return Ee[t] = r, r;
  }, "doEval"), gi = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, He = $e(), At = pi(), Yu = He.call(Ve, Array.prototype.concat), Gu = He.call(di, Array.prototype.splice), mi = He.call(Ve, String.prototype.
  replace), Ot = He.call(Ve, String.prototype.slice), Vu = He.call(Ve, RegExp.prototype.exec), Hu = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
  Ku = /\\(\\)?/g, Ju = /* @__PURE__ */ i(function(t) {
    var r = Ot(t, 0, 1), n = Ot(t, -1);
    if (r === "%" && n !== "%")
      throw new je("invalid intrinsic syntax, expected closing `%`");
    if (n === "%" && r !== "%")
      throw new je("invalid intrinsic syntax, expected opening `%`");
    var o = [];
    return mi(t, Hu, function(s, c, u, a) {
      o[o.length] = u ? mi(a, Ku, "$1") : c || s;
    }), o;
  }, "stringToPath"), Xu = /* @__PURE__ */ i(function(t, r) {
    var n = t, o;
    if (At(gi, n) && (o = gi[n], n = "%" + o[0] + "%"), At(Ee, n)) {
      var s = Ee[n];
      if (s === Ie && (s = Wu(n)), typeof s > "u" && !r)
        throw new Ne("intrinsic " + t + " exists, but is not available. Please file an issue!");
      return {
        alias: o,
        name: n,
        value: s
      };
    }
    throw new je("intrinsic " + t + " does not exist!");
  }, "getBaseIntrinsic");
  bi.exports = /* @__PURE__ */ i(function(t, r) {
    if (typeof t != "string" || t.length === 0)
      throw new Ne("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof r != "boolean")
      throw new Ne('"allowMissing" argument must be a boolean');
    if (Vu(/^%?[^%]*%?$/, t) === null)
      throw new je("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var n = Ju(t), o = n.length > 0 ? n[0] : "", s = Xu("%" + o + "%", r), c = s.name, u = s.value, a = !1, f = s.alias;
    f && (o = f[0], Gu(n, Yu([0, 1], f)));
    for (var y = 1, l = !0; y < n.length; y += 1) {
      var h = n[y], g = Ot(h, 0, 1), m = Ot(h, -1);
      if ((g === '"' || g === "'" || g === "`" || m === '"' || m === "'" || m === "`") && g !== m)
        throw new je("property names with quotes must have matching quotes");
      if ((h === "constructor" || !l) && (a = !0), o += "." + h, c = "%" + o + "%", At(Ee, c))
        u = Ee[c];
      else if (u != null) {
        if (!(h in u)) {
          if (!r)
            throw new Ne("base intrinsic for " + t + " exists, but the property is not available.");
          return;
        }
        if (Ge && y + 1 >= n.length) {
          var p = Ge(u, h);
          l = !!p, l && "get" in p && !("originalValue" in p.get) ? u = p.get : u = u[h];
        } else
          l = At(u, h), u = u[h];
        l && !a && (Ee[c] = u);
      }
    }
    return u;
  }, "GetIntrinsic");
});

// ../node_modules/define-data-property/index.js
var Oi = _((Fg, Ai) => {
  "use strict";
  var Si = Ye(), Zu = Ar(), Me = We(), Ei = Ce();
  Ai.exports = /* @__PURE__ */ i(function(t, r, n) {
    if (!t || typeof t != "object" && typeof t != "function")
      throw new Me("`obj` must be an object or a function`");
    if (typeof r != "string" && typeof r != "symbol")
      throw new Me("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new Me("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new Me("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new Me("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new Me("`loose`, if provided, must be a boolean");
    var o = arguments.length > 3 ? arguments[3] : null, s = arguments.length > 4 ? arguments[4] : null, c = arguments.length > 5 ? arguments[5] :
    null, u = arguments.length > 6 ? arguments[6] : !1, a = !!Ei && Ei(t, r);
    if (Si)
      Si(t, r, {
        configurable: c === null && a ? a.configurable : !c,
        enumerable: o === null && a ? a.enumerable : !o,
        value: n,
        writable: s === null && a ? a.writable : !s
      });
    else if (u || !o && !s && !c)
      t[r] = n;
    else
      throw new Zu("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, "defineDataProperty");
});

// ../node_modules/has-property-descriptors/index.js
var Ti = _((Dg, wi) => {
  "use strict";
  var $r = Ye(), _i = /* @__PURE__ */ i(function() {
    return !!$r;
  }, "hasPropertyDescriptors");
  _i.hasArrayLengthDefineBug = /* @__PURE__ */ i(function() {
    if (!$r)
      return null;
    try {
      return $r([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, "hasArrayLengthDefineBug");
  wi.exports = _i;
});

// ../node_modules/set-function-length/index.js
var Ii = _((kg, Ri) => {
  "use strict";
  var Qu = _t(), Pi = Oi(), el = Ti()(), Ci = Ce(), $i = We(), tl = Qu("%Math.floor%");
  Ri.exports = /* @__PURE__ */ i(function(t, r) {
    if (typeof t != "function")
      throw new $i("`fn` is not a function");
    if (typeof r != "number" || r < 0 || r > 4294967295 || tl(r) !== r)
      throw new $i("`length` must be a positive 32-bit integer");
    var n = arguments.length > 2 && !!arguments[2], o = !0, s = !0;
    if ("length" in t && Ci) {
      var c = Ci(t, "length");
      c && !c.configurable && (o = !1), c && !c.writable && (s = !1);
    }
    return (o || s || !n) && (el ? Pi(
      /** @type {Parameters<define>[0]} */
      t,
      "length",
      r,
      !0,
      !0
    ) : Pi(
      /** @type {Parameters<define>[0]} */
      t,
      "length",
      r
    )), t;
  }, "setFunctionLength");
});

// ../node_modules/call-bind-apply-helpers/applyBind.js
var ji = _((qg, Ni) => {
  "use strict";
  var rl = $e(), nl = St(), ol = wr();
  Ni.exports = /* @__PURE__ */ i(function() {
    return ol(rl, nl, arguments);
  }, "applyBind");
});

// ../node_modules/call-bind/index.js
var Rr = _((Wg, wt) => {
  "use strict";
  var il = Ii(), Mi = Ye(), sl = Et(), xi = ji();
  wt.exports = /* @__PURE__ */ i(function(t) {
    var r = sl(arguments), n = t.length - (arguments.length - 1);
    return il(
      r,
      1 + (n > 0 ? n : 0),
      !0
    );
  }, "callBind");
  Mi ? Mi(wt.exports, "apply", { value: xi }) : wt.exports.apply = xi;
});

// ../node_modules/call-bind/callBound.js
var Di = _((Gg, Li) => {
  "use strict";
  var vi = _t(), Fi = Rr(), cl = Fi(vi("String.prototype.indexOf"));
  Li.exports = /* @__PURE__ */ i(function(t, r) {
    var n = vi(t, !!r);
    return typeof n == "function" && cl(t, ".prototype.") > -1 ? Fi(n) : n;
  }, "callBoundIntrinsic");
});

// ../node_modules/is-arguments/index.js
var Ui = _((Hg, ki) => {
  "use strict";
  var al = mt()(), ul = Di(), Ir = ul("Object.prototype.toString"), Tt = /* @__PURE__ */ i(function(t) {
    return al && t && typeof t == "object" && Symbol.toStringTag in t ? !1 : Ir(t) === "[object Arguments]";
  }, "isArguments"), Bi = /* @__PURE__ */ i(function(t) {
    return Tt(t) ? !0 : t !== null && typeof t == "object" && typeof t.length == "number" && t.length >= 0 && Ir(t) !== "[object Array]" && Ir(
    t.callee) === "[object Function]";
  }, "isArguments"), ll = function() {
    return Tt(arguments);
  }();
  Tt.isLegacyArguments = Bi;
  ki.exports = ll ? Tt : Bi;
});

// ../node_modules/is-generator-function/index.js
var Wi = _((Jg, zi) => {
  "use strict";
  var fl = Object.prototype.toString, pl = Function.prototype.toString, yl = /^\s*(?:function)?\*/, qi = mt()(), Nr = Object.getPrototypeOf,
  gl = /* @__PURE__ */ i(function() {
    if (!qi)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, "getGeneratorFunc"), jr;
  zi.exports = /* @__PURE__ */ i(function(t) {
    if (typeof t != "function")
      return !1;
    if (yl.test(pl.call(t)))
      return !0;
    if (!qi) {
      var r = fl.call(t);
      return r === "[object GeneratorFunction]";
    }
    if (!Nr)
      return !1;
    if (typeof jr > "u") {
      var n = gl();
      jr = n ? Nr(n) : !1;
    }
    return Nr(t) === jr;
  }, "isGeneratorFunction");
});

// ../node_modules/is-callable/index.js
var Hi = _((Zg, Vi) => {
  "use strict";
  var Gi = Function.prototype.toString, xe = typeof Reflect == "object" && Reflect !== null && Reflect.apply, xr, Pt;
  if (typeof xe == "function" && typeof Object.defineProperty == "function")
    try {
      xr = Object.defineProperty({}, "length", {
        get: /* @__PURE__ */ i(function() {
          throw Pt;
        }, "get")
      }), Pt = {}, xe(function() {
        throw 42;
      }, null, xr);
    } catch (e) {
      e !== Pt && (xe = null);
    }
  else
    xe = null;
  var ml = /^\s*class\b/, vr = /* @__PURE__ */ i(function(t) {
    try {
      var r = Gi.call(t);
      return ml.test(r);
    } catch {
      return !1;
    }
  }, "isES6ClassFunction"), Mr = /* @__PURE__ */ i(function(t) {
    try {
      return vr(t) ? !1 : (Gi.call(t), !0);
    } catch {
      return !1;
    }
  }, "tryFunctionToStr"), Ct = Object.prototype.toString, hl = "[object Object]", dl = "[object Function]", bl = "[object GeneratorFunction]",
  Sl = "[object HTMLAllCollection]", El = "[object HTML document.all class]", Al = "[object HTMLCollection]", Ol = typeof Symbol == "functio\
n" && !!Symbol.toStringTag, _l = !(0 in [,]), Fr = /* @__PURE__ */ i(function() {
    return !1;
  }, "isDocumentDotAll");
  typeof document == "object" && (Yi = document.all, Ct.call(Yi) === Ct.call(document.all) && (Fr = /* @__PURE__ */ i(function(t) {
    if ((_l || !t) && (typeof t > "u" || typeof t == "object"))
      try {
        var r = Ct.call(t);
        return (r === Sl || r === El || r === Al || r === hl) && t("") == null;
      } catch {
      }
    return !1;
  }, "isDocumentDotAll")));
  var Yi;
  Vi.exports = /* @__PURE__ */ i(xe ? function(t) {
    if (Fr(t))
      return !0;
    if (!t || typeof t != "function" && typeof t != "object")
      return !1;
    try {
      xe(t, null, xr);
    } catch (r) {
      if (r !== Pt)
        return !1;
    }
    return !vr(t) && Mr(t);
  } : function(t) {
    if (Fr(t))
      return !0;
    if (!t || typeof t != "function" && typeof t != "object")
      return !1;
    if (Ol)
      return Mr(t);
    if (vr(t))
      return !1;
    var r = Ct.call(t);
    return r !== dl && r !== bl && !/^\[object HTML/.test(r) ? !1 : Mr(t);
  }, "isCallable");
});

// ../node_modules/for-each/index.js
var Xi = _((em, Ji) => {
  "use strict";
  var wl = Hi(), Tl = Object.prototype.toString, Ki = Object.prototype.hasOwnProperty, Pl = /* @__PURE__ */ i(function(t, r, n) {
    for (var o = 0, s = t.length; o < s; o++)
      Ki.call(t, o) && (n == null ? r(t[o], o, t) : r.call(n, t[o], o, t));
  }, "forEachArray"), Cl = /* @__PURE__ */ i(function(t, r, n) {
    for (var o = 0, s = t.length; o < s; o++)
      n == null ? r(t.charAt(o), o, t) : r.call(n, t.charAt(o), o, t);
  }, "forEachString"), $l = /* @__PURE__ */ i(function(t, r, n) {
    for (var o in t)
      Ki.call(t, o) && (n == null ? r(t[o], o, t) : r.call(n, t[o], o, t));
  }, "forEachObject"), Rl = /* @__PURE__ */ i(function(t, r, n) {
    if (!wl(r))
      throw new TypeError("iterator must be a function");
    var o;
    arguments.length >= 3 && (o = n), Tl.call(t) === "[object Array]" ? Pl(t, r, o) : typeof t == "string" ? Cl(t, r, o) : $l(t, r, o);
  }, "forEach");
  Ji.exports = Rl;
});

// ../node_modules/possible-typed-array-names/index.js
var Qi = _((rm, Zi) => {
  "use strict";
  Zi.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ];
});

// ../node_modules/available-typed-arrays/index.js
var ts = _((nm, es) => {
  "use strict";
  var Lr = Qi(), Il = typeof globalThis > "u" ? global : globalThis;
  es.exports = /* @__PURE__ */ i(function() {
    for (var t = [], r = 0; r < Lr.length; r++)
      typeof Il[Lr[r]] == "function" && (t[t.length] = Lr[r]);
    return t;
  }, "availableTypedArrays");
});

// ../node_modules/call-bound/index.js
var is = _((im, os) => {
  "use strict";
  var rs = _t(), ns = Et(), Nl = ns([rs("%String.prototype.indexOf%")]);
  os.exports = /* @__PURE__ */ i(function(t, r) {
    var n = (
      /** @type {Parameters<typeof callBindBasic>[0][0]} */
      rs(t, !!r)
    );
    return typeof n == "function" && Nl(t, ".prototype.") > -1 ? ns([n]) : n;
  }, "callBoundIntrinsic");
});

// ../node_modules/which-typed-array/index.js
var qr = _((cm, us) => {
  "use strict";
  var Rt = Xi(), jl = ts(), ss = Rr(), kr = is(), $t = Ce(), Ml = kr("Object.prototype.toString"), as = mt()(), cs = typeof globalThis > "u" ?
  global : globalThis, Br = jl(), Ur = kr("String.prototype.slice"), Dr = Object.getPrototypeOf, xl = kr("Array.prototype.indexOf", !0) || /* @__PURE__ */ i(
  function(t, r) {
    for (var n = 0; n < t.length; n += 1)
      if (t[n] === r)
        return n;
    return -1;
  }, "indexOf"), It = { __proto__: null };
  as && $t && Dr ? Rt(Br, function(e) {
    var t = new cs[e]();
    if (Symbol.toStringTag in t) {
      var r = Dr(t), n = $t(r, Symbol.toStringTag);
      if (!n) {
        var o = Dr(r);
        n = $t(o, Symbol.toStringTag);
      }
      It["$" + e] = ss(n.get);
    }
  }) : Rt(Br, function(e) {
    var t = new cs[e](), r = t.slice || t.set;
    r && (It["$" + e] = ss(r));
  });
  var vl = /* @__PURE__ */ i(function(t) {
    var r = !1;
    return Rt(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      It,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(n, o) {
        if (!r)
          try {
            "$" + n(t) === o && (r = Ur(o, 1));
          } catch {
          }
      }
    ), r;
  }, "tryAllTypedArrays"), Fl = /* @__PURE__ */ i(function(t) {
    var r = !1;
    return Rt(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      It,
      /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
      function(n, o) {
        if (!r)
          try {
            n(t), r = Ur(o, 1);
          } catch {
          }
      }
    ), r;
  }, "tryAllSlices");
  us.exports = /* @__PURE__ */ i(function(t) {
    if (!t || typeof t != "object")
      return !1;
    if (!as) {
      var r = Ur(Ml(t), 8, -1);
      return xl(Br, r) > -1 ? r : r !== "Object" ? !1 : Fl(t);
    }
    return $t ? vl(t) : null;
  }, "whichTypedArray");
});

// ../node_modules/is-typed-array/index.js
var fs = _((um, ls) => {
  "use strict";
  var Ll = qr();
  ls.exports = /* @__PURE__ */ i(function(t) {
    return !!Ll(t);
  }, "isTypedArray");
});

// ../node_modules/util/support/types.js
var Ts = _((C) => {
  "use strict";
  var Dl = Ui(), Bl = Wi(), ae = qr(), ps = fs();
  function ve(e) {
    return e.call.bind(e);
  }
  i(ve, "uncurryThis");
  var ys = typeof BigInt < "u", gs = typeof Symbol < "u", ne = ve(Object.prototype.toString), kl = ve(Number.prototype.valueOf), Ul = ve(String.
  prototype.valueOf), ql = ve(Boolean.prototype.valueOf);
  ys && (ms = ve(BigInt.prototype.valueOf));
  var ms;
  gs && (hs = ve(Symbol.prototype.valueOf));
  var hs;
  function Je(e, t) {
    if (typeof e != "object")
      return !1;
    try {
      return t(e), !0;
    } catch {
      return !1;
    }
  }
  i(Je, "checkBoxedPrimitive");
  C.isArgumentsObject = Dl;
  C.isGeneratorFunction = Bl;
  C.isTypedArray = ps;
  function zl(e) {
    return typeof Promise < "u" && e instanceof Promise || e !== null && typeof e == "object" && typeof e.then == "function" && typeof e.catch ==
    "function";
  }
  i(zl, "isPromise");
  C.isPromise = zl;
  function Wl(e) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : ps(e) || bs(e);
  }
  i(Wl, "isArrayBufferView");
  C.isArrayBufferView = Wl;
  function Yl(e) {
    return ae(e) === "Uint8Array";
  }
  i(Yl, "isUint8Array");
  C.isUint8Array = Yl;
  function Gl(e) {
    return ae(e) === "Uint8ClampedArray";
  }
  i(Gl, "isUint8ClampedArray");
  C.isUint8ClampedArray = Gl;
  function Vl(e) {
    return ae(e) === "Uint16Array";
  }
  i(Vl, "isUint16Array");
  C.isUint16Array = Vl;
  function Hl(e) {
    return ae(e) === "Uint32Array";
  }
  i(Hl, "isUint32Array");
  C.isUint32Array = Hl;
  function Kl(e) {
    return ae(e) === "Int8Array";
  }
  i(Kl, "isInt8Array");
  C.isInt8Array = Kl;
  function Jl(e) {
    return ae(e) === "Int16Array";
  }
  i(Jl, "isInt16Array");
  C.isInt16Array = Jl;
  function Xl(e) {
    return ae(e) === "Int32Array";
  }
  i(Xl, "isInt32Array");
  C.isInt32Array = Xl;
  function Zl(e) {
    return ae(e) === "Float32Array";
  }
  i(Zl, "isFloat32Array");
  C.isFloat32Array = Zl;
  function Ql(e) {
    return ae(e) === "Float64Array";
  }
  i(Ql, "isFloat64Array");
  C.isFloat64Array = Ql;
  function ef(e) {
    return ae(e) === "BigInt64Array";
  }
  i(ef, "isBigInt64Array");
  C.isBigInt64Array = ef;
  function tf(e) {
    return ae(e) === "BigUint64Array";
  }
  i(tf, "isBigUint64Array");
  C.isBigUint64Array = tf;
  function Nt(e) {
    return ne(e) === "[object Map]";
  }
  i(Nt, "isMapToString");
  Nt.working = typeof Map < "u" && Nt(/* @__PURE__ */ new Map());
  function rf(e) {
    return typeof Map > "u" ? !1 : Nt.working ? Nt(e) : e instanceof Map;
  }
  i(rf, "isMap");
  C.isMap = rf;
  function jt(e) {
    return ne(e) === "[object Set]";
  }
  i(jt, "isSetToString");
  jt.working = typeof Set < "u" && jt(/* @__PURE__ */ new Set());
  function nf(e) {
    return typeof Set > "u" ? !1 : jt.working ? jt(e) : e instanceof Set;
  }
  i(nf, "isSet");
  C.isSet = nf;
  function Mt(e) {
    return ne(e) === "[object WeakMap]";
  }
  i(Mt, "isWeakMapToString");
  Mt.working = typeof WeakMap < "u" && Mt(/* @__PURE__ */ new WeakMap());
  function of(e) {
    return typeof WeakMap > "u" ? !1 : Mt.working ? Mt(e) : e instanceof WeakMap;
  }
  i(of, "isWeakMap");
  C.isWeakMap = of;
  function Wr(e) {
    return ne(e) === "[object WeakSet]";
  }
  i(Wr, "isWeakSetToString");
  Wr.working = typeof WeakSet < "u" && Wr(/* @__PURE__ */ new WeakSet());
  function sf(e) {
    return Wr(e);
  }
  i(sf, "isWeakSet");
  C.isWeakSet = sf;
  function xt(e) {
    return ne(e) === "[object ArrayBuffer]";
  }
  i(xt, "isArrayBufferToString");
  xt.working = typeof ArrayBuffer < "u" && xt(new ArrayBuffer());
  function ds(e) {
    return typeof ArrayBuffer > "u" ? !1 : xt.working ? xt(e) : e instanceof ArrayBuffer;
  }
  i(ds, "isArrayBuffer");
  C.isArrayBuffer = ds;
  function vt(e) {
    return ne(e) === "[object DataView]";
  }
  i(vt, "isDataViewToString");
  vt.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && vt(new DataView(new ArrayBuffer(1), 0, 1));
  function bs(e) {
    return typeof DataView > "u" ? !1 : vt.working ? vt(e) : e instanceof DataView;
  }
  i(bs, "isDataView");
  C.isDataView = bs;
  var zr = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function Ke(e) {
    return ne(e) === "[object SharedArrayBuffer]";
  }
  i(Ke, "isSharedArrayBufferToString");
  function Ss(e) {
    return typeof zr > "u" ? !1 : (typeof Ke.working > "u" && (Ke.working = Ke(new zr())), Ke.working ? Ke(e) : e instanceof zr);
  }
  i(Ss, "isSharedArrayBuffer");
  C.isSharedArrayBuffer = Ss;
  function cf(e) {
    return ne(e) === "[object AsyncFunction]";
  }
  i(cf, "isAsyncFunction");
  C.isAsyncFunction = cf;
  function af(e) {
    return ne(e) === "[object Map Iterator]";
  }
  i(af, "isMapIterator");
  C.isMapIterator = af;
  function uf(e) {
    return ne(e) === "[object Set Iterator]";
  }
  i(uf, "isSetIterator");
  C.isSetIterator = uf;
  function lf(e) {
    return ne(e) === "[object Generator]";
  }
  i(lf, "isGeneratorObject");
  C.isGeneratorObject = lf;
  function ff(e) {
    return ne(e) === "[object WebAssembly.Module]";
  }
  i(ff, "isWebAssemblyCompiledModule");
  C.isWebAssemblyCompiledModule = ff;
  function Es(e) {
    return Je(e, kl);
  }
  i(Es, "isNumberObject");
  C.isNumberObject = Es;
  function As(e) {
    return Je(e, Ul);
  }
  i(As, "isStringObject");
  C.isStringObject = As;
  function Os(e) {
    return Je(e, ql);
  }
  i(Os, "isBooleanObject");
  C.isBooleanObject = Os;
  function _s(e) {
    return ys && Je(e, ms);
  }
  i(_s, "isBigIntObject");
  C.isBigIntObject = _s;
  function ws(e) {
    return gs && Je(e, hs);
  }
  i(ws, "isSymbolObject");
  C.isSymbolObject = ws;
  function pf(e) {
    return Es(e) || As(e) || Os(e) || _s(e) || ws(e);
  }
  i(pf, "isBoxedPrimitive");
  C.isBoxedPrimitive = pf;
  function yf(e) {
    return typeof Uint8Array < "u" && (ds(e) || Ss(e));
  }
  i(yf, "isAnyArrayBuffer");
  C.isAnyArrayBuffer = yf;
  ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(e) {
    Object.defineProperty(C, e, {
      enumerable: !1,
      value: /* @__PURE__ */ i(function() {
        throw new Error(e + " is not supported in userland");
      }, "value")
    });
  });
});

// ../node_modules/util/support/isBufferBrowser.js
var Cs = _((ym, Ps) => {
  Ps.exports = /* @__PURE__ */ i(function(t) {
    return t && typeof t == "object" && typeof t.copy == "function" && typeof t.fill == "function" && typeof t.readUInt8 == "function";
  }, "isBuffer");
});

// ../node_modules/inherits/inherits_browser.js
var $s = _((mm, Yr) => {
  typeof Object.create == "function" ? Yr.exports = /* @__PURE__ */ i(function(t, r) {
    r && (t.super_ = r, t.prototype = Object.create(r.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  }, "inherits") : Yr.exports = /* @__PURE__ */ i(function(t, r) {
    if (r) {
      t.super_ = r;
      var n = /* @__PURE__ */ i(function() {
      }, "TempCtor");
      n.prototype = r.prototype, t.prototype = new n(), t.prototype.constructor = t;
    }
  }, "inherits");
});

// ../node_modules/util/util.js
var xs = _(($) => {
  var Rs = Object.getOwnPropertyDescriptors || /* @__PURE__ */ i(function(t) {
    for (var r = Object.keys(t), n = {}, o = 0; o < r.length; o++)
      n[r[o]] = Object.getOwnPropertyDescriptor(t, r[o]);
    return n;
  }, "getOwnPropertyDescriptors"), gf = /%[sdj%]/g;
  $.format = function(e) {
    if (!qt(e)) {
      for (var t = [], r = 0; r < arguments.length; r++)
        t.push(de(arguments[r]));
      return t.join(" ");
    }
    for (var r = 1, n = arguments, o = n.length, s = String(e).replace(gf, function(u) {
      if (u === "%%") return "%";
      if (r >= o) return u;
      switch (u) {
        case "%s":
          return String(n[r++]);
        case "%d":
          return Number(n[r++]);
        case "%j":
          try {
            return JSON.stringify(n[r++]);
          } catch {
            return "[Circular]";
          }
        default:
          return u;
      }
    }), c = n[r]; r < o; c = n[++r])
      Ut(c) || !Fe(c) ? s += " " + c : s += " " + de(c);
    return s;
  };
  $.deprecate = function(e, t) {
    if (typeof process < "u" && process.noDeprecation === !0)
      return e;
    if (typeof process > "u")
      return function() {
        return $.deprecate(e, t).apply(this, arguments);
      };
    var r = !1;
    function n() {
      if (!r) {
        if (process.throwDeprecation)
          throw new Error(t);
        process.traceDeprecation ? console.trace(t) : console.error(t), r = !0;
      }
      return e.apply(this, arguments);
    }
    return i(n, "deprecated"), n;
  };
  var Ft = {}, Is = /^$/;
  process.env.NODE_DEBUG && (Lt = process.env.NODE_DEBUG, Lt = Lt.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "\
$|^").toUpperCase(), Is = new RegExp("^" + Lt + "$", "i"));
  var Lt;
  $.debuglog = function(e) {
    if (e = e.toUpperCase(), !Ft[e])
      if (Is.test(e)) {
        var t = process.pid;
        Ft[e] = function() {
          var r = $.format.apply($, arguments);
          console.error("%s %d: %s", e, t, r);
        };
      } else
        Ft[e] = function() {
        };
    return Ft[e];
  };
  function de(e, t) {
    var r = {
      seen: [],
      stylize: hf
    };
    return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), Kr(t) ? r.showHidden = t :
    t && $._extend(r, t), Oe(r.showHidden) && (r.showHidden = !1), Oe(r.depth) && (r.depth = 2), Oe(r.colors) && (r.colors = !1), Oe(r.customInspect) &&
    (r.customInspect = !0), r.colors && (r.stylize = mf), Bt(r, e, r.depth);
  }
  i(de, "inspect");
  $.inspect = de;
  de.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  };
  de.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function mf(e, t) {
    var r = de.styles[t];
    return r ? "\x1B[" + de.colors[r][0] + "m" + e + "\x1B[" + de.colors[r][1] + "m" : e;
  }
  i(mf, "stylizeWithColor");
  function hf(e, t) {
    return e;
  }
  i(hf, "stylizeNoColor");
  function df(e) {
    var t = {};
    return e.forEach(function(r, n) {
      t[r] = !0;
    }), t;
  }
  i(df, "arrayToHash");
  function Bt(e, t, r) {
    if (e.customInspect && t && Dt(t.inspect) && // Filter out the util module, it's inspect function is special
    t.inspect !== $.inspect && // Also filter out any prototype objects using the circular check.
    !(t.constructor && t.constructor.prototype === t)) {
      var n = t.inspect(r, e);
      return qt(n) || (n = Bt(e, n, r)), n;
    }
    var o = bf(e, t);
    if (o)
      return o;
    var s = Object.keys(t), c = df(s);
    if (e.showHidden && (s = Object.getOwnPropertyNames(t)), Ze(t) && (s.indexOf("message") >= 0 || s.indexOf("description") >= 0))
      return Gr(t);
    if (s.length === 0) {
      if (Dt(t)) {
        var u = t.name ? ": " + t.name : "";
        return e.stylize("[Function" + u + "]", "special");
      }
      if (Xe(t))
        return e.stylize(RegExp.prototype.toString.call(t), "regexp");
      if (kt(t))
        return e.stylize(Date.prototype.toString.call(t), "date");
      if (Ze(t))
        return Gr(t);
    }
    var a = "", f = !1, y = ["{", "}"];
    if (Ns(t) && (f = !0, y = ["[", "]"]), Dt(t)) {
      var l = t.name ? ": " + t.name : "";
      a = " [Function" + l + "]";
    }
    if (Xe(t) && (a = " " + RegExp.prototype.toString.call(t)), kt(t) && (a = " " + Date.prototype.toUTCString.call(t)), Ze(t) && (a = " " +
    Gr(t)), s.length === 0 && (!f || t.length == 0))
      return y[0] + a + y[1];
    if (r < 0)
      return Xe(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special");
    e.seen.push(t);
    var h;
    return f ? h = Sf(e, t, r, c, s) : h = s.map(function(g) {
      return Hr(e, t, r, c, g, f);
    }), e.seen.pop(), Ef(h, a, y);
  }
  i(Bt, "formatValue");
  function bf(e, t) {
    if (Oe(t))
      return e.stylize("undefined", "undefined");
    if (qt(t)) {
      var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return e.stylize(r, "string");
    }
    if (js(t))
      return e.stylize("" + t, "number");
    if (Kr(t))
      return e.stylize("" + t, "boolean");
    if (Ut(t))
      return e.stylize("null", "null");
  }
  i(bf, "formatPrimitive");
  function Gr(e) {
    return "[" + Error.prototype.toString.call(e) + "]";
  }
  i(Gr, "formatError");
  function Sf(e, t, r, n, o) {
    for (var s = [], c = 0, u = t.length; c < u; ++c)
      Ms(t, String(c)) ? s.push(Hr(
        e,
        t,
        r,
        n,
        String(c),
        !0
      )) : s.push("");
    return o.forEach(function(a) {
      a.match(/^\d+$/) || s.push(Hr(
        e,
        t,
        r,
        n,
        a,
        !0
      ));
    }), s;
  }
  i(Sf, "formatArray");
  function Hr(e, t, r, n, o, s) {
    var c, u, a;
    if (a = Object.getOwnPropertyDescriptor(t, o) || { value: t[o] }, a.get ? a.set ? u = e.stylize("[Getter/Setter]", "special") : u = e.stylize(
    "[Getter]", "special") : a.set && (u = e.stylize("[Setter]", "special")), Ms(n, o) || (c = "[" + o + "]"), u || (e.seen.indexOf(a.value) <
    0 ? (Ut(r) ? u = Bt(e, a.value, null) : u = Bt(e, a.value, r - 1), u.indexOf(`
`) > -1 && (s ? u = u.split(`
`).map(function(f) {
      return "  " + f;
    }).join(`
`).slice(2) : u = `
` + u.split(`
`).map(function(f) {
      return "   " + f;
    }).join(`
`))) : u = e.stylize("[Circular]", "special")), Oe(c)) {
      if (s && o.match(/^\d+$/))
        return u;
      c = JSON.stringify("" + o), c.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (c = c.slice(1, -1), c = e.stylize(c, "name")) : (c = c.replace(
      /'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), c = e.stylize(c, "string"));
    }
    return c + ": " + u;
  }
  i(Hr, "formatProperty");
  function Ef(e, t, r) {
    var n = 0, o = e.reduce(function(s, c) {
      return n++, c.indexOf(`
`) >= 0 && n++, s + c.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return o > 60 ? r[0] + (t === "" ? "" : t + `
 `) + " " + e.join(`,
  `) + " " + r[1] : r[0] + t + " " + e.join(", ") + " " + r[1];
  }
  i(Ef, "reduceToSingleString");
  $.types = Ts();
  function Ns(e) {
    return Array.isArray(e);
  }
  i(Ns, "isArray");
  $.isArray = Ns;
  function Kr(e) {
    return typeof e == "boolean";
  }
  i(Kr, "isBoolean");
  $.isBoolean = Kr;
  function Ut(e) {
    return e === null;
  }
  i(Ut, "isNull");
  $.isNull = Ut;
  function Af(e) {
    return e == null;
  }
  i(Af, "isNullOrUndefined");
  $.isNullOrUndefined = Af;
  function js(e) {
    return typeof e == "number";
  }
  i(js, "isNumber");
  $.isNumber = js;
  function qt(e) {
    return typeof e == "string";
  }
  i(qt, "isString");
  $.isString = qt;
  function Of(e) {
    return typeof e == "symbol";
  }
  i(Of, "isSymbol");
  $.isSymbol = Of;
  function Oe(e) {
    return e === void 0;
  }
  i(Oe, "isUndefined");
  $.isUndefined = Oe;
  function Xe(e) {
    return Fe(e) && Jr(e) === "[object RegExp]";
  }
  i(Xe, "isRegExp");
  $.isRegExp = Xe;
  $.types.isRegExp = Xe;
  function Fe(e) {
    return typeof e == "object" && e !== null;
  }
  i(Fe, "isObject");
  $.isObject = Fe;
  function kt(e) {
    return Fe(e) && Jr(e) === "[object Date]";
  }
  i(kt, "isDate");
  $.isDate = kt;
  $.types.isDate = kt;
  function Ze(e) {
    return Fe(e) && (Jr(e) === "[object Error]" || e instanceof Error);
  }
  i(Ze, "isError");
  $.isError = Ze;
  $.types.isNativeError = Ze;
  function Dt(e) {
    return typeof e == "function";
  }
  i(Dt, "isFunction");
  $.isFunction = Dt;
  function _f(e) {
    return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || // ES6 symbol
    typeof e > "u";
  }
  i(_f, "isPrimitive");
  $.isPrimitive = _f;
  $.isBuffer = Cs();
  function Jr(e) {
    return Object.prototype.toString.call(e);
  }
  i(Jr, "objectToString");
  function Vr(e) {
    return e < 10 ? "0" + e.toString(10) : e.toString(10);
  }
  i(Vr, "pad");
  var wf = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function Tf() {
    var e = /* @__PURE__ */ new Date(), t = [
      Vr(e.getHours()),
      Vr(e.getMinutes()),
      Vr(e.getSeconds())
    ].join(":");
    return [e.getDate(), wf[e.getMonth()], t].join(" ");
  }
  i(Tf, "timestamp");
  $.log = function() {
    console.log("%s - %s", Tf(), $.format.apply($, arguments));
  };
  $.inherits = $s();
  $._extend = function(e, t) {
    if (!t || !Fe(t)) return e;
    for (var r = Object.keys(t), n = r.length; n--; )
      e[r[n]] = t[r[n]];
    return e;
  };
  function Ms(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }
  i(Ms, "hasOwnProperty");
  var Ae = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  $.promisify = /* @__PURE__ */ i(function(t) {
    if (typeof t != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (Ae && t[Ae]) {
      var r = t[Ae];
      if (typeof r != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(r, Ae, {
        value: r,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), r;
    }
    function r() {
      for (var n, o, s = new Promise(function(a, f) {
        n = a, o = f;
      }), c = [], u = 0; u < arguments.length; u++)
        c.push(arguments[u]);
      c.push(function(a, f) {
        a ? o(a) : n(f);
      });
      try {
        t.apply(this, c);
      } catch (a) {
        o(a);
      }
      return s;
    }
    return i(r, "fn"), Object.setPrototypeOf(r, Object.getPrototypeOf(t)), Ae && Object.defineProperty(r, Ae, {
      value: r,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      r,
      Rs(t)
    );
  }, "promisify");
  $.promisify.custom = Ae;
  function Pf(e, t) {
    if (!e) {
      var r = new Error("Promise was rejected with a falsy value");
      r.reason = e, e = r;
    }
    return t(e);
  }
  i(Pf, "callbackifyOnRejected");
  function Cf(e) {
    if (typeof e != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function t() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r.push(arguments[n]);
      var o = r.pop();
      if (typeof o != "function")
        throw new TypeError("The last argument must be of type Function");
      var s = this, c = /* @__PURE__ */ i(function() {
        return o.apply(s, arguments);
      }, "cb");
      e.apply(this, r).then(
        function(u) {
          process.nextTick(c.bind(null, null, u));
        },
        function(u) {
          process.nextTick(Pf.bind(null, u, c));
        }
      );
    }
    return i(t, "callbackified"), Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(
      t,
      Rs(e)
    ), t;
  }
  i(Cf, "callbackify");
  $.callbackify = Cf;
});

// src/instrumenter/instrumenter.ts
import { once as $p } from "storybook/internal/client-logger";
import {
  FORCE_REMOUNT as Sc,
  SET_CURRENT_STORY as Rp,
  STORY_RENDER_PHASE_CHANGED as Ip
} from "storybook/internal/core-events";
import { global as V } from "@storybook/global";

// ../node_modules/tinyrainbow/dist/chunk-BVHSVHOK.js
var Tc = {
  reset: [0, 0],
  bold: [1, 22, "\x1B[22m\x1B[1m"],
  dim: [2, 22, "\x1B[22m\x1B[2m"],
  italic: [3, 23],
  underline: [4, 24],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],
  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  gray: [90, 39],
  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  blackBright: [90, 39],
  redBright: [91, 39],
  greenBright: [92, 39],
  yellowBright: [93, 39],
  blueBright: [94, 39],
  magentaBright: [95, 39],
  cyanBright: [96, 39],
  whiteBright: [97, 39],
  bgBlackBright: [100, 49],
  bgRedBright: [101, 49],
  bgGreenBright: [102, 49],
  bgYellowBright: [103, 49],
  bgBlueBright: [104, 49],
  bgMagentaBright: [105, 49],
  bgCyanBright: [106, 49],
  bgWhiteBright: [107, 49]
}, Pc = Object.entries(Tc);
function Xt(e) {
  return String(e);
}
i(Xt, "a");
Xt.open = "";
Xt.close = "";
function bn(e = !1) {
  let t = typeof process < "u" ? process : void 0, r = t?.env || {}, n = t?.argv || [];
  return !("NO_COLOR" in r || n.includes("--no-color")) && ("FORCE_COLOR" in r || n.includes("--color") || t?.platform === "win32" || e && r.
  TERM !== "dumb" || "CI" in r) || typeof window < "u" && !!window.chrome;
}
i(bn, "C");
function Sn(e = !1) {
  let t = bn(e), r = /* @__PURE__ */ i((c, u, a, f) => {
    let y = "", l = 0;
    do
      y += c.substring(l, f) + a, l = f + u.length, f = c.indexOf(u, l);
    while (~f);
    return y + c.substring(l);
  }, "i"), n = /* @__PURE__ */ i((c, u, a = c) => {
    let f = /* @__PURE__ */ i((y) => {
      let l = String(y), h = l.indexOf(u, c.length);
      return ~h ? c + r(l, u, a, h) + u : c + l + u;
    }, "o");
    return f.open = c, f.close = u, f;
  }, "g"), o = {
    isColorSupported: t
  }, s = /* @__PURE__ */ i((c) => `\x1B[${c}m`, "d");
  for (let [c, u] of Pc)
    o[c] = t ? n(
      s(u[0]),
      s(u[1]),
      u[2]
    ) : Xt;
  return o;
}
i(Sn, "p");

// ../node_modules/tinyrainbow/dist/browser.js
var ie = Sn();

// ../node_modules/@vitest/pretty-format/dist/index.js
function jn(e, t) {
  return t.forEach(function(r) {
    r && typeof r != "string" && !Array.isArray(r) && Object.keys(r).forEach(function(n) {
      if (n !== "default" && !(n in e)) {
        var o = Object.getOwnPropertyDescriptor(r, n);
        Object.defineProperty(e, n, o.get ? o : {
          enumerable: !0,
          get: /* @__PURE__ */ i(function() {
            return r[n];
          }, "get")
        });
      }
    });
  }), Object.freeze(e);
}
i(jn, "_mergeNamespaces");
function Cc(e, t) {
  let r = Object.keys(e), n = t === null ? r : r.sort(t);
  if (Object.getOwnPropertySymbols)
    for (let o of Object.getOwnPropertySymbols(e))
      Object.getOwnPropertyDescriptor(e, o).enumerable && n.push(o);
  return n;
}
i(Cc, "getKeysOfEnumerableProperties");
function qe(e, t, r, n, o, s, c = ": ") {
  let u = "", a = 0, f = e.next();
  if (!f.done) {
    u += t.spacingOuter;
    let y = r + t.indent;
    for (; !f.done; ) {
      if (u += y, a++ === t.maxWidth) {
        u += "\u2026";
        break;
      }
      let l = s(f.value[0], t, y, n, o), h = s(f.value[1], t, y, n, o);
      u += l + c + h, f = e.next(), f.done ? t.min || (u += ",") : u += `,${t.spacingInner}`;
    }
    u += t.spacingOuter + r;
  }
  return u;
}
i(qe, "printIteratorEntries");
function rr(e, t, r, n, o, s) {
  let c = "", u = 0, a = e.next();
  if (!a.done) {
    c += t.spacingOuter;
    let f = r + t.indent;
    for (; !a.done; ) {
      if (c += f, u++ === t.maxWidth) {
        c += "\u2026";
        break;
      }
      c += s(a.value, t, f, n, o), a = e.next(), a.done ? t.min || (c += ",") : c += `,${t.spacingInner}`;
    }
    c += t.spacingOuter + r;
  }
  return c;
}
i(rr, "printIteratorValues");
function it(e, t, r, n, o, s) {
  let c = "";
  e = e instanceof ArrayBuffer ? new DataView(e) : e;
  let u = /* @__PURE__ */ i((f) => f instanceof DataView, "isDataView"), a = u(e) ? e.byteLength : e.length;
  if (a > 0) {
    c += t.spacingOuter;
    let f = r + t.indent;
    for (let y = 0; y < a; y++) {
      if (c += f, y === t.maxWidth) {
        c += "\u2026";
        break;
      }
      (u(e) || y in e) && (c += s(u(e) ? e.getInt8(y) : e[y], t, f, n, o)), y < a - 1 ? c += `,${t.spacingInner}` : t.min || (c += ",");
    }
    c += t.spacingOuter + r;
  }
  return c;
}
i(it, "printListItems");
function nr(e, t, r, n, o, s) {
  let c = "", u = Cc(e, t.compareKeys);
  if (u.length > 0) {
    c += t.spacingOuter;
    let a = r + t.indent;
    for (let f = 0; f < u.length; f++) {
      let y = u[f], l = s(y, t, a, n, o), h = s(e[y], t, a, n, o);
      c += `${a + l}: ${h}`, f < u.length - 1 ? c += `,${t.spacingInner}` : t.min || (c += ",");
    }
    c += t.spacingOuter + r;
  }
  return c;
}
i(nr, "printObjectProperties");
var $c = typeof Symbol == "function" && Symbol.for ? Symbol.for("jest.asymmetricMatcher") : 1267621, nt = " ", Rc = /* @__PURE__ */ i((e, t, r, n, o, s) => {
  let c = e.toString();
  if (c === "ArrayContaining" || c === "ArrayNotContaining")
    return ++n > t.maxDepth ? `[${c}]` : `${c + nt}[${it(e.sample, t, r, n, o, s)}]`;
  if (c === "ObjectContaining" || c === "ObjectNotContaining")
    return ++n > t.maxDepth ? `[${c}]` : `${c + nt}{${nr(e.sample, t, r, n, o, s)}}`;
  if (c === "StringMatching" || c === "StringNotMatching" || c === "StringContaining" || c === "StringNotContaining")
    return c + nt + s(e.sample, t, r, n, o);
  if (typeof e.toAsymmetricMatcher != "function")
    throw new TypeError(`Asymmetric matcher ${e.constructor.name} does not implement toAsymmetricMatcher()`);
  return e.toAsymmetricMatcher();
}, "serialize$5"), Ic = /* @__PURE__ */ i((e) => e && e.$$typeof === $c, "test$5"), Nc = {
  serialize: Rc,
  test: Ic
}, jc = " ", Mn = /* @__PURE__ */ new Set(["DOMStringMap", "NamedNodeMap"]), Mc = /^(?:HTML\w*Collection|NodeList)$/;
function xc(e) {
  return Mn.has(e) || Mc.test(e);
}
i(xc, "testName");
var vc = /* @__PURE__ */ i((e) => e && e.constructor && !!e.constructor.name && xc(e.constructor.name), "test$4");
function Fc(e) {
  return e.constructor.name === "NamedNodeMap";
}
i(Fc, "isNamedNodeMap");
var Lc = /* @__PURE__ */ i((e, t, r, n, o, s) => {
  let c = e.constructor.name;
  return ++n > t.maxDepth ? `[${c}]` : (t.min ? "" : c + jc) + (Mn.has(c) ? `{${nr(Fc(e) ? [...e].reduce((u, a) => (u[a.name] = a.value, u),
  {}) : { ...e }, t, r, n, o, s)}}` : `[${it([...e], t, r, n, o, s)}]`);
}, "serialize$4"), Dc = {
  serialize: Lc,
  test: vc
};
function xn(e) {
  return e.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
}
i(xn, "escapeHTML");
function or(e, t, r, n, o, s, c) {
  let u = n + r.indent, a = r.colors;
  return e.map((f) => {
    let y = t[f], l = c(y, r, u, o, s);
    return typeof y != "string" && (l.includes(`
`) && (l = r.spacingOuter + u + l + r.spacingOuter + n), l = `{${l}}`), `${r.spacingInner + n + a.prop.open + f + a.prop.close}=${a.value.open}${l}${a.
    value.close}`;
  }).join("");
}
i(or, "printProps");
function ir(e, t, r, n, o, s) {
  return e.map((c) => t.spacingOuter + r + (typeof c == "string" ? vn(c, t) : s(c, t, r, n, o))).join("");
}
i(ir, "printChildren");
function vn(e, t) {
  let r = t.colors.content;
  return r.open + xn(e) + r.close;
}
i(vn, "printText");
function Bc(e, t) {
  let r = t.colors.comment;
  return `${r.open}<!--${xn(e)}-->${r.close}`;
}
i(Bc, "printComment");
function sr(e, t, r, n, o) {
  let s = n.colors.tag;
  return `${s.open}<${e}${t && s.close + t + n.spacingOuter + o + s.open}${r ? `>${s.close}${r}${n.spacingOuter}${o}${s.open}</${e}` : `${t &&
  !n.min ? "" : " "}/`}>${s.close}`;
}
i(sr, "printElement");
function cr(e, t) {
  let r = t.colors.tag;
  return `${r.open}<${e}${r.close} \u2026${r.open} />${r.close}`;
}
i(cr, "printElementAsLeaf");
var kc = 1, Fn = 3, Ln = 8, Dn = 11, Uc = /^(?:(?:HTML|SVG)\w*)?Element$/;
function qc(e) {
  try {
    return typeof e.hasAttribute == "function" && e.hasAttribute("is");
  } catch {
    return !1;
  }
}
i(qc, "testHasAttribute");
function zc(e) {
  let t = e.constructor.name, { nodeType: r, tagName: n } = e, o = typeof n == "string" && n.includes("-") || qc(e);
  return r === kc && (Uc.test(t) || o) || r === Fn && t === "Text" || r === Ln && t === "Comment" || r === Dn && t === "DocumentFragment";
}
i(zc, "testNode");
var Wc = /* @__PURE__ */ i((e) => {
  var t;
  return (e == null || (t = e.constructor) === null || t === void 0 ? void 0 : t.name) && zc(e);
}, "test$3");
function Yc(e) {
  return e.nodeType === Fn;
}
i(Yc, "nodeIsText");
function Gc(e) {
  return e.nodeType === Ln;
}
i(Gc, "nodeIsComment");
function Zt(e) {
  return e.nodeType === Dn;
}
i(Zt, "nodeIsFragment");
var Vc = /* @__PURE__ */ i((e, t, r, n, o, s) => {
  if (Yc(e))
    return vn(e.data, t);
  if (Gc(e))
    return Bc(e.data, t);
  let c = Zt(e) ? "DocumentFragment" : e.tagName.toLowerCase();
  return ++n > t.maxDepth ? cr(c, t) : sr(c, or(Zt(e) ? [] : Array.from(e.attributes, (u) => u.name).sort(), Zt(e) ? {} : [...e.attributes].
  reduce((u, a) => (u[a.name] = a.value, u), {}), t, r + t.indent, n, o, s), ir(Array.prototype.slice.call(e.childNodes || e.children), t, r +
  t.indent, n, o, s), t, r);
}, "serialize$3"), Hc = {
  serialize: Vc,
  test: Wc
}, Kc = "@@__IMMUTABLE_ITERABLE__@@", Jc = "@@__IMMUTABLE_LIST__@@", Xc = "@@__IMMUTABLE_KEYED__@@", Zc = "@@__IMMUTABLE_MAP__@@", En = "@@_\
_IMMUTABLE_ORDERED__@@", Qc = "@@__IMMUTABLE_RECORD__@@", ea = "@@__IMMUTABLE_SEQ__@@", ta = "@@__IMMUTABLE_SET__@@", ra = "@@__IMMUTABLE_ST\
ACK__@@", Pe = /* @__PURE__ */ i((e) => `Immutable.${e}`, "getImmutableName"), ct = /* @__PURE__ */ i((e) => `[${e}]`, "printAsLeaf"), Ue = "\
 ", An = "\u2026";
function na(e, t, r, n, o, s, c) {
  return ++n > t.maxDepth ? ct(Pe(c)) : `${Pe(c) + Ue}{${qe(e.entries(), t, r, n, o, s)}}`;
}
i(na, "printImmutableEntries");
function oa(e) {
  let t = 0;
  return { next() {
    if (t < e._keys.length) {
      let r = e._keys[t++];
      return {
        done: !1,
        value: [r, e.get(r)]
      };
    }
    return {
      done: !0,
      value: void 0
    };
  } };
}
i(oa, "getRecordEntries");
function ia(e, t, r, n, o, s) {
  let c = Pe(e._name || "Record");
  return ++n > t.maxDepth ? ct(c) : `${c + Ue}{${qe(oa(e), t, r, n, o, s)}}`;
}
i(ia, "printImmutableRecord");
function sa(e, t, r, n, o, s) {
  let c = Pe("Seq");
  return ++n > t.maxDepth ? ct(c) : e[Xc] ? `${c + Ue}{${e._iter || e._object ? qe(e.entries(), t, r, n, o, s) : An}}` : `${c + Ue}[${e._iter ||
  e._array || e._collection || e._iterable ? rr(e.values(), t, r, n, o, s) : An}]`;
}
i(sa, "printImmutableSeq");
function Qt(e, t, r, n, o, s, c) {
  return ++n > t.maxDepth ? ct(Pe(c)) : `${Pe(c) + Ue}[${rr(e.values(), t, r, n, o, s)}]`;
}
i(Qt, "printImmutableValues");
var ca = /* @__PURE__ */ i((e, t, r, n, o, s) => e[Zc] ? na(e, t, r, n, o, s, e[En] ? "OrderedMap" : "Map") : e[Jc] ? Qt(e, t, r, n, o, s, "\
List") : e[ta] ? Qt(e, t, r, n, o, s, e[En] ? "OrderedSet" : "Set") : e[ra] ? Qt(e, t, r, n, o, s, "Stack") : e[ea] ? sa(e, t, r, n, o, s) :
ia(e, t, r, n, o, s), "serialize$2"), aa = /* @__PURE__ */ i((e) => e && (e[Kc] === !0 || e[Qc] === !0), "test$2"), ua = {
  serialize: ca,
  test: aa
};
function Bn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
i(Bn, "getDefaultExportFromCjs");
var er = { exports: {} };
var j = {};
var On;
function la() {
  return On || (On = 1, function() {
    function e(p) {
      if (typeof p == "object" && p !== null) {
        var d = p.$$typeof;
        switch (d) {
          case t:
            switch (p = p.type, p) {
              case n:
              case s:
              case o:
              case f:
              case y:
                return p;
              default:
                switch (p = p && p.$$typeof, p) {
                  case u:
                  case a:
                  case h:
                  case l:
                    return p;
                  case c:
                    return p;
                  default:
                    return d;
                }
            }
          case r:
            return d;
        }
      }
    }
    i(e, "typeOf");
    var t = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("reac\
t.strict_mode"), s = Symbol.for("react.profiler"), c = Symbol.for("react.consumer"), u = Symbol.for("react.context"), a = Symbol.for("react.\
forward_ref"), f = Symbol.for("react.suspense"), y = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), h = Symbol.for("react.\
lazy"), g = Symbol.for("react.offscreen"), m = Symbol.for("react.client.reference");
    j.ContextConsumer = c, j.ContextProvider = u, j.Element = t, j.ForwardRef = a, j.Fragment = n, j.Lazy = h, j.Memo = l, j.Portal = r, j.Profiler =
    s, j.StrictMode = o, j.Suspense = f, j.SuspenseList = y, j.isContextConsumer = function(p) {
      return e(p) === c;
    }, j.isContextProvider = function(p) {
      return e(p) === u;
    }, j.isElement = function(p) {
      return typeof p == "object" && p !== null && p.$$typeof === t;
    }, j.isForwardRef = function(p) {
      return e(p) === a;
    }, j.isFragment = function(p) {
      return e(p) === n;
    }, j.isLazy = function(p) {
      return e(p) === h;
    }, j.isMemo = function(p) {
      return e(p) === l;
    }, j.isPortal = function(p) {
      return e(p) === r;
    }, j.isProfiler = function(p) {
      return e(p) === s;
    }, j.isStrictMode = function(p) {
      return e(p) === o;
    }, j.isSuspense = function(p) {
      return e(p) === f;
    }, j.isSuspenseList = function(p) {
      return e(p) === y;
    }, j.isValidElementType = function(p) {
      return typeof p == "string" || typeof p == "function" || p === n || p === s || p === o || p === f || p === y || p === g || typeof p ==
      "object" && p !== null && (p.$$typeof === h || p.$$typeof === l || p.$$typeof === u || p.$$typeof === c || p.$$typeof === a || p.$$typeof ===
      m || p.getModuleId !== void 0);
    }, j.typeOf = e;
  }()), j;
}
i(la, "requireReactIs_development$1");
var _n;
function fa() {
  return _n || (_n = 1, er.exports = la()), er.exports;
}
i(fa, "requireReactIs$1");
var kn = fa(), pa = /* @__PURE__ */ Bn(kn), ya = /* @__PURE__ */ jn({
  __proto__: null,
  default: pa
}, [kn]), tr = { exports: {} };
var I = {};
var wn;
function ga() {
  return wn || (wn = 1, function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"),
    o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), c = Symbol.for("react.context"), u = Symbol.for("react.server_contex\
t"), a = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), y = Symbol.for("react.suspense_list"), l = Symbol.for("react.mem\
o"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), m = !1, p = !1, d = !1, S = !1, A = !1, T;
    T = Symbol.for("react.module.reference");
    function b(w) {
      return !!(typeof w == "string" || typeof w == "function" || w === r || w === o || A || w === n || w === f || w === y || S || w === g ||
      m || p || d || typeof w == "object" && w !== null && (w.$$typeof === h || w.$$typeof === l || w.$$typeof === s || w.$$typeof === c || w.
      $$typeof === a || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      w.$$typeof === T || w.getModuleId !== void 0));
    }
    i(b, "isValidElementType");
    function E(w) {
      if (typeof w == "object" && w !== null) {
        var Jt = w.$$typeof;
        switch (Jt) {
          case e:
            var rt = w.type;
            switch (rt) {
              case r:
              case o:
              case n:
              case f:
              case y:
                return rt;
              default:
                var dn = rt && rt.$$typeof;
                switch (dn) {
                  case u:
                  case c:
                  case a:
                  case h:
                  case l:
                  case s:
                    return dn;
                  default:
                    return Jt;
                }
            }
          case t:
            return Jt;
        }
      }
    }
    i(E, "typeOf");
    var P = c, O = s, N = e, Z = a, oe = r, v = h, z = l, Q = t, G = o, x = n, L = f, D = y, ee = !1, k = !1;
    function K(w) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    i(K, "isAsyncMode");
    function le(w) {
      return k || (k = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    i(le, "isConcurrentMode");
    function J(w) {
      return E(w) === c;
    }
    i(J, "isContextConsumer");
    function X(w) {
      return E(w) === s;
    }
    i(X, "isContextProvider");
    function pe(w) {
      return typeof w == "object" && w !== null && w.$$typeof === e;
    }
    i(pe, "isElement");
    function te(w) {
      return E(w) === a;
    }
    i(te, "isForwardRef");
    function H(w) {
      return E(w) === r;
    }
    i(H, "isFragment");
    function fe(w) {
      return E(w) === h;
    }
    i(fe, "isLazy");
    function Te(w) {
      return E(w) === l;
    }
    i(Te, "isMemo");
    function me(w) {
      return E(w) === t;
    }
    i(me, "isPortal");
    function ke(w) {
      return E(w) === o;
    }
    i(ke, "isProfiler");
    function et(w) {
      return E(w) === n;
    }
    i(et, "isStrictMode");
    function tt(w) {
      return E(w) === f;
    }
    i(tt, "isSuspense");
    function _c(w) {
      return E(w) === y;
    }
    i(_c, "isSuspenseList"), I.ContextConsumer = P, I.ContextProvider = O, I.Element = N, I.ForwardRef = Z, I.Fragment = oe, I.Lazy = v, I.Memo =
    z, I.Portal = Q, I.Profiler = G, I.StrictMode = x, I.Suspense = L, I.SuspenseList = D, I.isAsyncMode = K, I.isConcurrentMode = le, I.isContextConsumer =
    J, I.isContextProvider = X, I.isElement = pe, I.isForwardRef = te, I.isFragment = H, I.isLazy = fe, I.isMemo = Te, I.isPortal = me, I.isProfiler =
    ke, I.isStrictMode = et, I.isSuspense = tt, I.isSuspenseList = _c, I.isValidElementType = b, I.typeOf = E;
  }()), I;
}
i(ga, "requireReactIs_development");
var Tn;
function ma() {
  return Tn || (Tn = 1, tr.exports = ga()), tr.exports;
}
i(ma, "requireReactIs");
var Un = ma(), ha = /* @__PURE__ */ Bn(Un), da = /* @__PURE__ */ jn({
  __proto__: null,
  default: ha
}, [Un]), ba = [
  "isAsyncMode",
  "isConcurrentMode",
  "isContextConsumer",
  "isContextProvider",
  "isElement",
  "isForwardRef",
  "isFragment",
  "isLazy",
  "isMemo",
  "isPortal",
  "isProfiler",
  "isStrictMode",
  "isSuspense",
  "isSuspenseList",
  "isValidElementType"
], be = Object.fromEntries(ba.map((e) => [e, (t) => da[e](t) || ya[e](t)]));
function qn(e, t = []) {
  if (Array.isArray(e))
    for (let r of e)
      qn(r, t);
  else e != null && e !== !1 && e !== "" && t.push(e);
  return t;
}
i(qn, "getChildren");
function Pn(e) {
  let t = e.type;
  if (typeof t == "string")
    return t;
  if (typeof t == "function")
    return t.displayName || t.name || "Unknown";
  if (be.isFragment(e))
    return "React.Fragment";
  if (be.isSuspense(e))
    return "React.Suspense";
  if (typeof t == "object" && t !== null) {
    if (be.isContextProvider(e))
      return "Context.Provider";
    if (be.isContextConsumer(e))
      return "Context.Consumer";
    if (be.isForwardRef(e)) {
      if (t.displayName)
        return t.displayName;
      let r = t.render.displayName || t.render.name || "";
      return r === "" ? "ForwardRef" : `ForwardRef(${r})`;
    }
    if (be.isMemo(e)) {
      let r = t.displayName || t.type.displayName || t.type.name || "";
      return r === "" ? "Memo" : `Memo(${r})`;
    }
  }
  return "UNDEFINED";
}
i(Pn, "getType");
function Sa(e) {
  let { props: t } = e;
  return Object.keys(t).filter((r) => r !== "children" && t[r] !== void 0).sort();
}
i(Sa, "getPropKeys$1");
var Ea = /* @__PURE__ */ i((e, t, r, n, o, s) => ++n > t.maxDepth ? cr(Pn(e), t) : sr(Pn(e), or(Sa(e), e.props, t, r + t.indent, n, o, s), ir(
qn(e.props.children), t, r + t.indent, n, o, s), t, r), "serialize$1"), Aa = /* @__PURE__ */ i((e) => e != null && be.isElement(e), "test$1"),
Oa = {
  serialize: Ea,
  test: Aa
}, _a = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.test.json") : 245830487;
function wa(e) {
  let { props: t } = e;
  return t ? Object.keys(t).filter((r) => t[r] !== void 0).sort() : [];
}
i(wa, "getPropKeys");
var Ta = /* @__PURE__ */ i((e, t, r, n, o, s) => ++n > t.maxDepth ? cr(e.type, t) : sr(e.type, e.props ? or(wa(e), e.props, t, r + t.indent,
n, o, s) : "", e.children ? ir(e.children, t, r + t.indent, n, o, s) : "", t, r), "serialize"), Pa = /* @__PURE__ */ i((e) => e && e.$$typeof ===
_a, "test"), Ca = {
  serialize: Ta,
  test: Pa
}, zn = Object.prototype.toString, $a = Date.prototype.toISOString, Ra = Error.prototype.toString, Cn = RegExp.prototype.toString;
function ot(e) {
  return typeof e.constructor == "function" && e.constructor.name || "Object";
}
i(ot, "getConstructorName");
function Ia(e) {
  return typeof window < "u" && e === window;
}
i(Ia, "isWindow");
var Na = /^Symbol\((.*)\)(.*)$/, ja = /\n/g, ur = class ur extends Error {
  constructor(t, r) {
    super(t), this.stack = r, this.name = this.constructor.name;
  }
};
i(ur, "PrettyFormatPluginError");
var st = ur;
function Ma(e) {
  return e === "[object Array]" || e === "[object ArrayBuffer]" || e === "[object DataView]" || e === "[object Float32Array]" || e === "[obj\
ect Float64Array]" || e === "[object Int8Array]" || e === "[object Int16Array]" || e === "[object Int32Array]" || e === "[object Uint8Array]" ||
  e === "[object Uint8ClampedArray]" || e === "[object Uint16Array]" || e === "[object Uint32Array]";
}
i(Ma, "isToStringedArrayType");
function xa(e) {
  return Object.is(e, -0) ? "-0" : String(e);
}
i(xa, "printNumber");
function va(e) {
  return `${e}n`;
}
i(va, "printBigInt");
function $n(e, t) {
  return t ? `[Function ${e.name || "anonymous"}]` : "[Function]";
}
i($n, "printFunction");
function Rn(e) {
  return String(e).replace(Na, "Symbol($1)");
}
i(Rn, "printSymbol");
function In(e) {
  return `[${Ra.call(e)}]`;
}
i(In, "printError");
function Wn(e, t, r, n) {
  if (e === !0 || e === !1)
    return `${e}`;
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  let o = typeof e;
  if (o === "number")
    return xa(e);
  if (o === "bigint")
    return va(e);
  if (o === "string")
    return n ? `"${e.replaceAll(/"|\\/g, "\\$&")}"` : `"${e}"`;
  if (o === "function")
    return $n(e, t);
  if (o === "symbol")
    return Rn(e);
  let s = zn.call(e);
  return s === "[object WeakMap]" ? "WeakMap {}" : s === "[object WeakSet]" ? "WeakSet {}" : s === "[object Function]" || s === "[object Gen\
eratorFunction]" ? $n(e, t) : s === "[object Symbol]" ? Rn(e) : s === "[object Date]" ? Number.isNaN(+e) ? "Date { NaN }" : $a.call(e) : s ===
  "[object Error]" ? In(e) : s === "[object RegExp]" ? r ? Cn.call(e).replaceAll(/[$()*+.?[\\\]^{|}]/g, "\\$&") : Cn.call(e) : e instanceof Error ?
  In(e) : null;
}
i(Wn, "printBasicValue");
function Yn(e, t, r, n, o, s) {
  if (o.includes(e))
    return "[Circular]";
  o = [...o], o.push(e);
  let c = ++n > t.maxDepth, u = t.min;
  if (t.callToJSON && !c && e.toJSON && typeof e.toJSON == "function" && !s)
    return he(e.toJSON(), t, r, n, o, !0);
  let a = zn.call(e);
  return a === "[object Arguments]" ? c ? "[Arguments]" : `${u ? "" : "Arguments "}[${it(e, t, r, n, o, he)}]` : Ma(a) ? c ? `[${e.constructor.
  name}]` : `${u || !t.printBasicPrototype && e.constructor.name === "Array" ? "" : `${e.constructor.name} `}[${it(e, t, r, n, o, he)}]` : a ===
  "[object Map]" ? c ? "[Map]" : `Map {${qe(e.entries(), t, r, n, o, he, " => ")}}` : a === "[object Set]" ? c ? "[Set]" : `Set {${rr(e.values(),
  t, r, n, o, he)}}` : c || Ia(e) ? `[${ot(e)}]` : `${u || !t.printBasicPrototype && ot(e) === "Object" ? "" : `${ot(e)} `}{${nr(e, t, r, n,
  o, he)}}`;
}
i(Yn, "printComplexValue");
var Fa = {
  test: /* @__PURE__ */ i((e) => e && e instanceof Error, "test"),
  serialize(e, t, r, n, o, s) {
    if (o.includes(e))
      return "[Circular]";
    o = [...o, e];
    let c = ++n > t.maxDepth, { message: u, cause: a, ...f } = e, y = {
      message: u,
      ...typeof a < "u" ? { cause: a } : {},
      ...e instanceof AggregateError ? { errors: e.errors } : {},
      ...f
    }, l = e.name !== "Error" ? e.name : ot(e);
    return c ? `[${l}]` : `${l} {${qe(Object.entries(y).values(), t, r, n, o, s)}}`;
  }
};
function La(e) {
  return e.serialize != null;
}
i(La, "isNewPlugin");
function Gn(e, t, r, n, o, s) {
  let c;
  try {
    c = La(e) ? e.serialize(t, r, n, o, s, he) : e.print(t, (u) => he(u, r, n, o, s), (u) => {
      let a = n + r.indent;
      return a + u.replaceAll(ja, `
${a}`);
    }, {
      edgeSpacing: r.spacingOuter,
      min: r.min,
      spacing: r.spacingInner
    }, r.colors);
  } catch (u) {
    throw new st(u.message, u.stack);
  }
  if (typeof c != "string")
    throw new TypeError(`pretty-format: Plugin must return type "string" but instead returned "${typeof c}".`);
  return c;
}
i(Gn, "printPlugin");
function Vn(e, t) {
  for (let r of e)
    try {
      if (r.test(t))
        return r;
    } catch (n) {
      throw new st(n.message, n.stack);
    }
  return null;
}
i(Vn, "findPlugin");
function he(e, t, r, n, o, s) {
  let c = Vn(t.plugins, e);
  if (c !== null)
    return Gn(c, e, t, r, n, o);
  let u = Wn(e, t.printFunctionName, t.escapeRegex, t.escapeString);
  return u !== null ? u : Yn(e, t, r, n, o, s);
}
i(he, "printer");
var ar = {
  comment: "gray",
  content: "reset",
  prop: "yellow",
  tag: "cyan",
  value: "green"
}, Hn = Object.keys(ar), se = {
  callToJSON: !0,
  compareKeys: void 0,
  escapeRegex: !1,
  escapeString: !0,
  highlight: !1,
  indent: 2,
  maxDepth: Number.POSITIVE_INFINITY,
  maxWidth: Number.POSITIVE_INFINITY,
  min: !1,
  plugins: [],
  printBasicPrototype: !0,
  printFunctionName: !0,
  theme: ar
};
function Da(e) {
  for (let t of Object.keys(e))
    if (!Object.prototype.hasOwnProperty.call(se, t))
      throw new Error(`pretty-format: Unknown option "${t}".`);
  if (e.min && e.indent !== void 0 && e.indent !== 0)
    throw new Error('pretty-format: Options "min" and "indent" cannot be used together.');
}
i(Da, "validateOptions");
function Ba() {
  return Hn.reduce((e, t) => {
    let r = ar[t], n = r && ie[r];
    if (n && typeof n.close == "string" && typeof n.open == "string")
      e[t] = n;
    else
      throw new Error(`pretty-format: Option "theme" has a key "${t}" whose value "${r}" is undefined in ansi-styles.`);
    return e;
  }, /* @__PURE__ */ Object.create(null));
}
i(Ba, "getColorsHighlight");
function ka() {
  return Hn.reduce((e, t) => (e[t] = {
    close: "",
    open: ""
  }, e), /* @__PURE__ */ Object.create(null));
}
i(ka, "getColorsEmpty");
function Kn(e) {
  return e?.printFunctionName ?? se.printFunctionName;
}
i(Kn, "getPrintFunctionName");
function Jn(e) {
  return e?.escapeRegex ?? se.escapeRegex;
}
i(Jn, "getEscapeRegex");
function Xn(e) {
  return e?.escapeString ?? se.escapeString;
}
i(Xn, "getEscapeString");
function Nn(e) {
  return {
    callToJSON: e?.callToJSON ?? se.callToJSON,
    colors: e?.highlight ? Ba() : ka(),
    compareKeys: typeof e?.compareKeys == "function" || e?.compareKeys === null ? e.compareKeys : se.compareKeys,
    escapeRegex: Jn(e),
    escapeString: Xn(e),
    indent: e?.min ? "" : Ua(e?.indent ?? se.indent),
    maxDepth: e?.maxDepth ?? se.maxDepth,
    maxWidth: e?.maxWidth ?? se.maxWidth,
    min: e?.min ?? se.min,
    plugins: e?.plugins ?? se.plugins,
    printBasicPrototype: e?.printBasicPrototype ?? !0,
    printFunctionName: Kn(e),
    spacingInner: e?.min ? " " : `
`,
    spacingOuter: e?.min ? "" : `
`
  };
}
i(Nn, "getConfig");
function Ua(e) {
  return Array.from({ length: e + 1 }).join(" ");
}
i(Ua, "createIndent");
function re(e, t) {
  if (t && (Da(t), t.plugins)) {
    let n = Vn(t.plugins, e);
    if (n !== null)
      return Gn(n, e, Nn(t), "", 0, []);
  }
  let r = Wn(e, Kn(t), Jn(t), Xn(t));
  return r !== null ? r : Yn(e, Nn(t), "", 0, []);
}
i(re, "format");
var ze = {
  AsymmetricMatcher: Nc,
  DOMCollection: Dc,
  DOMElement: Hc,
  Immutable: ua,
  ReactElement: Oa,
  ReactTestComponent: Ca,
  Error: Fa
};

// ../node_modules/loupe/lib/helpers.js
var Zn = {
  bold: ["1", "22"],
  dim: ["2", "22"],
  italic: ["3", "23"],
  underline: ["4", "24"],
  // 5 & 6 are blinking
  inverse: ["7", "27"],
  hidden: ["8", "28"],
  strike: ["9", "29"],
  // 10-20 are fonts
  // 21-29 are resets for 1-9
  black: ["30", "39"],
  red: ["31", "39"],
  green: ["32", "39"],
  yellow: ["33", "39"],
  blue: ["34", "39"],
  magenta: ["35", "39"],
  cyan: ["36", "39"],
  white: ["37", "39"],
  brightblack: ["30;1", "39"],
  brightred: ["31;1", "39"],
  brightgreen: ["32;1", "39"],
  brightyellow: ["33;1", "39"],
  brightblue: ["34;1", "39"],
  brightmagenta: ["35;1", "39"],
  brightcyan: ["36;1", "39"],
  brightwhite: ["37;1", "39"],
  grey: ["90", "39"]
}, qa = {
  special: "cyan",
  number: "yellow",
  bigint: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  symbol: "green",
  date: "magenta",
  regexp: "red"
}, ye = "\u2026";
function za(e, t) {
  let r = Zn[qa[t]] || Zn[t] || "";
  return r ? `\x1B[${r[0]}m${String(e)}\x1B[${r[1]}m` : String(e);
}
i(za, "colorise");
function Qn({
  showHidden: e = !1,
  depth: t = 2,
  colors: r = !1,
  customInspect: n = !0,
  showProxy: o = !1,
  maxArrayLength: s = 1 / 0,
  breakLength: c = 1 / 0,
  seen: u = [],
  // eslint-disable-next-line no-shadow
  truncate: a = 1 / 0,
  stylize: f = String
} = {}, y) {
  let l = {
    showHidden: !!e,
    depth: Number(t),
    colors: !!r,
    customInspect: !!n,
    showProxy: !!o,
    maxArrayLength: Number(s),
    breakLength: Number(c),
    truncate: Number(a),
    seen: u,
    inspect: y,
    stylize: f
  };
  return l.colors && (l.stylize = za), l;
}
i(Qn, "normaliseOptions");
function Wa(e) {
  return e >= "\uD800" && e <= "\uDBFF";
}
i(Wa, "isHighSurrogate");
function W(e, t, r = ye) {
  e = String(e);
  let n = r.length, o = e.length;
  if (n > t && o > n)
    return r;
  if (o > t && o > n) {
    let s = t - n;
    return s > 0 && Wa(e[s - 1]) && (s = s - 1), `${e.slice(0, s)}${r}`;
  }
  return e;
}
i(W, "truncate");
function B(e, t, r, n = ", ") {
  r = r || t.inspect;
  let o = e.length;
  if (o === 0)
    return "";
  let s = t.truncate, c = "", u = "", a = "";
  for (let f = 0; f < o; f += 1) {
    let y = f + 1 === e.length, l = f + 2 === e.length;
    a = `${ye}(${e.length - f})`;
    let h = e[f];
    t.truncate = s - c.length - (y ? 0 : n.length);
    let g = u || r(h, t) + (y ? "" : n), m = c.length + g.length, p = m + a.length;
    if (y && m > s && c.length + a.length <= s || !y && !l && p > s || (u = y ? "" : r(e[f + 1], t) + (l ? "" : n), !y && l && p > s && m + u.
    length > s))
      break;
    if (c += g, !y && !l && m + u.length >= s) {
      a = `${ye}(${e.length - f - 1})`;
      break;
    }
    a = "";
  }
  return `${c}${a}`;
}
i(B, "inspectList");
function Ya(e) {
  return e.match(/^[a-zA-Z_][a-zA-Z_0-9]*$/) ? e : JSON.stringify(e).replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
}
i(Ya, "quoteComplexKey");
function ge([e, t], r) {
  return r.truncate -= 2, typeof e == "string" ? e = Ya(e) : typeof e != "number" && (e = `[${r.inspect(e, r)}]`), r.truncate -= e.length, t =
  r.inspect(t, r), `${e}: ${t}`;
}
i(ge, "inspectProperty");

// ../node_modules/loupe/lib/array.js
function lr(e, t) {
  let r = Object.keys(e).slice(e.length);
  if (!e.length && !r.length)
    return "[]";
  t.truncate -= 4;
  let n = B(e, t);
  t.truncate -= n.length;
  let o = "";
  return r.length && (o = B(r.map((s) => [s, e[s]]), t, ge)), `[ ${n}${o ? `, ${o}` : ""} ]`;
}
i(lr, "inspectArray");

// ../node_modules/loupe/lib/typedarray.js
var Ga = /* @__PURE__ */ i((e) => typeof Buffer == "function" && e instanceof Buffer ? "Buffer" : e[Symbol.toStringTag] ? e[Symbol.toStringTag] :
e.constructor.name, "getArrayName");
function ce(e, t) {
  let r = Ga(e);
  t.truncate -= r.length + 4;
  let n = Object.keys(e).slice(e.length);
  if (!e.length && !n.length)
    return `${r}[]`;
  let o = "";
  for (let c = 0; c < e.length; c++) {
    let u = `${t.stylize(W(e[c], t.truncate), "number")}${c === e.length - 1 ? "" : ", "}`;
    if (t.truncate -= u.length, e[c] !== e.length && t.truncate <= 3) {
      o += `${ye}(${e.length - e[c] + 1})`;
      break;
    }
    o += u;
  }
  let s = "";
  return n.length && (s = B(n.map((c) => [c, e[c]]), t, ge)), `${r}[ ${o}${s ? `, ${s}` : ""} ]`;
}
i(ce, "inspectTypedArray");

// ../node_modules/loupe/lib/date.js
function fr(e, t) {
  let r = e.toJSON();
  if (r === null)
    return "Invalid Date";
  let n = r.split("T"), o = n[0];
  return t.stylize(`${o}T${W(n[1], t.truncate - o.length - 1)}`, "date");
}
i(fr, "inspectDate");

// ../node_modules/loupe/lib/function.js
function at(e, t) {
  let r = e[Symbol.toStringTag] || "Function", n = e.name;
  return n ? t.stylize(`[${r} ${W(n, t.truncate - 11)}]`, "special") : t.stylize(`[${r}]`, "special");
}
i(at, "inspectFunction");

// ../node_modules/loupe/lib/map.js
function Va([e, t], r) {
  return r.truncate -= 4, e = r.inspect(e, r), r.truncate -= e.length, t = r.inspect(t, r), `${e} => ${t}`;
}
i(Va, "inspectMapEntry");
function Ha(e) {
  let t = [];
  return e.forEach((r, n) => {
    t.push([n, r]);
  }), t;
}
i(Ha, "mapToEntries");
function pr(e, t) {
  return e.size === 0 ? "Map{}" : (t.truncate -= 7, `Map{ ${B(Ha(e), t, Va)} }`);
}
i(pr, "inspectMap");

// ../node_modules/loupe/lib/number.js
var Ka = Number.isNaN || ((e) => e !== e);
function ut(e, t) {
  return Ka(e) ? t.stylize("NaN", "number") : e === 1 / 0 ? t.stylize("Infinity", "number") : e === -1 / 0 ? t.stylize("-Infinity", "number") :
  e === 0 ? t.stylize(1 / e === 1 / 0 ? "+0" : "-0", "number") : t.stylize(W(String(e), t.truncate), "number");
}
i(ut, "inspectNumber");

// ../node_modules/loupe/lib/bigint.js
function lt(e, t) {
  let r = W(e.toString(), t.truncate - 1);
  return r !== ye && (r += "n"), t.stylize(r, "bigint");
}
i(lt, "inspectBigInt");

// ../node_modules/loupe/lib/regexp.js
function yr(e, t) {
  let r = e.toString().split("/")[2], n = t.truncate - (2 + r.length), o = e.source;
  return t.stylize(`/${W(o, n)}/${r}`, "regexp");
}
i(yr, "inspectRegExp");

// ../node_modules/loupe/lib/set.js
function Ja(e) {
  let t = [];
  return e.forEach((r) => {
    t.push(r);
  }), t;
}
i(Ja, "arrayFromSet");
function gr(e, t) {
  return e.size === 0 ? "Set{}" : (t.truncate -= 7, `Set{ ${B(Ja(e), t)} }`);
}
i(gr, "inspectSet");

// ../node_modules/loupe/lib/string.js
var eo = new RegExp("['\\u0000-\\u001f\\u007f-\\u009f\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\u\
ffff]", "g"), Xa = {
  "\b": "\\b",
  "	": "\\t",
  "\n": "\\n",
  "\f": "\\f",
  "\r": "\\r",
  "'": "\\'",
  "\\": "\\\\"
}, Za = 16, Qa = 4;
function eu(e) {
  return Xa[e] || `\\u${`0000${e.charCodeAt(0).toString(Za)}`.slice(-Qa)}`;
}
i(eu, "escape");
function ft(e, t) {
  return eo.test(e) && (e = e.replace(eo, eu)), t.stylize(`'${W(e, t.truncate - 2)}'`, "string");
}
i(ft, "inspectString");

// ../node_modules/loupe/lib/symbol.js
function pt(e) {
  return "description" in Symbol.prototype ? e.description ? `Symbol(${e.description})` : "Symbol()" : e.toString();
}
i(pt, "inspectSymbol");

// ../node_modules/loupe/lib/promise.js
var to = /* @__PURE__ */ i(() => "Promise{\u2026}", "getPromiseValue");
try {
  let { getPromiseDetails: e, kPending: t, kRejected: r } = process.binding("util");
  Array.isArray(e(Promise.resolve())) && (to = /* @__PURE__ */ i((n, o) => {
    let [s, c] = e(n);
    return s === t ? "Promise{<pending>}" : `Promise${s === r ? "!" : ""}{${o.inspect(c, o)}}`;
  }, "getPromiseValue"));
} catch {
}
var ro = to;

// ../node_modules/loupe/lib/object.js
function Se(e, t) {
  let r = Object.getOwnPropertyNames(e), n = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e) : [];
  if (r.length === 0 && n.length === 0)
    return "{}";
  if (t.truncate -= 4, t.seen = t.seen || [], t.seen.includes(e))
    return "[Circular]";
  t.seen.push(e);
  let o = B(r.map((u) => [u, e[u]]), t, ge), s = B(n.map((u) => [u, e[u]]), t, ge);
  t.seen.pop();
  let c = "";
  return o && s && (c = ", "), `{ ${o}${c}${s} }`;
}
i(Se, "inspectObject");

// ../node_modules/loupe/lib/class.js
var mr = typeof Symbol < "u" && Symbol.toStringTag ? Symbol.toStringTag : !1;
function hr(e, t) {
  let r = "";
  return mr && mr in e && (r = e[mr]), r = r || e.constructor.name, (!r || r === "_class") && (r = "<Anonymous Class>"), t.truncate -= r.length,
  `${r}${Se(e, t)}`;
}
i(hr, "inspectClass");

// ../node_modules/loupe/lib/arguments.js
function dr(e, t) {
  return e.length === 0 ? "Arguments[]" : (t.truncate -= 13, `Arguments[ ${B(e, t)} ]`);
}
i(dr, "inspectArguments");

// ../node_modules/loupe/lib/error.js
var tu = [
  "stack",
  "line",
  "column",
  "name",
  "message",
  "fileName",
  "lineNumber",
  "columnNumber",
  "number",
  "description",
  "cause"
];
function br(e, t) {
  let r = Object.getOwnPropertyNames(e).filter((c) => tu.indexOf(c) === -1), n = e.name;
  t.truncate -= n.length;
  let o = "";
  if (typeof e.message == "string" ? o = W(e.message, t.truncate) : r.unshift("message"), o = o ? `: ${o}` : "", t.truncate -= o.length + 5,
  t.seen = t.seen || [], t.seen.includes(e))
    return "[Circular]";
  t.seen.push(e);
  let s = B(r.map((c) => [c, e[c]]), t, ge);
  return `${n}${o}${s ? ` { ${s} }` : ""}`;
}
i(br, "inspectObject");

// ../node_modules/loupe/lib/html.js
function ru([e, t], r) {
  return r.truncate -= 3, t ? `${r.stylize(String(e), "yellow")}=${r.stylize(`"${t}"`, "string")}` : `${r.stylize(String(e), "yellow")}`;
}
i(ru, "inspectAttribute");
function yt(e, t) {
  return B(e, t, gt, `
`);
}
i(yt, "inspectHTMLCollection");
function gt(e, t) {
  let r = e.getAttributeNames(), n = e.tagName.toLowerCase(), o = t.stylize(`<${n}`, "special"), s = t.stylize(">", "special"), c = t.stylize(
  `</${n}>`, "special");
  t.truncate -= n.length * 2 + 5;
  let u = "";
  r.length > 0 && (u += " ", u += B(r.map((y) => [y, e.getAttribute(y)]), t, ru, " ")), t.truncate -= u.length;
  let a = t.truncate, f = yt(e.children, t);
  return f && f.length > a && (f = `${ye}(${e.children.length})`), `${o}${u}${s}${f}${c}`;
}
i(gt, "inspectHTML");

// ../node_modules/loupe/lib/index.js
var $f = typeof Symbol == "function" && typeof Symbol.for == "function", Xr = $f ? Symbol.for("chai/inspect") : "@@chai/inspect", Le = !1;
try {
  let e = xs();
  Le = e.inspect ? e.inspect.custom : !1;
} catch {
  Le = !1;
}
var vs = /* @__PURE__ */ new WeakMap(), Fs = {}, Ls = {
  undefined: /* @__PURE__ */ i((e, t) => t.stylize("undefined", "undefined"), "undefined"),
  null: /* @__PURE__ */ i((e, t) => t.stylize("null", "null"), "null"),
  boolean: /* @__PURE__ */ i((e, t) => t.stylize(String(e), "boolean"), "boolean"),
  Boolean: /* @__PURE__ */ i((e, t) => t.stylize(String(e), "boolean"), "Boolean"),
  number: ut,
  Number: ut,
  bigint: lt,
  BigInt: lt,
  string: ft,
  String: ft,
  function: at,
  Function: at,
  symbol: pt,
  // A Symbol polyfill will return `Symbol` not `symbol` from typedetect
  Symbol: pt,
  Array: lr,
  Date: fr,
  Map: pr,
  Set: gr,
  RegExp: yr,
  Promise: ro,
  // WeakSet, WeakMap are totally opaque to us
  WeakSet: /* @__PURE__ */ i((e, t) => t.stylize("WeakSet{\u2026}", "special"), "WeakSet"),
  WeakMap: /* @__PURE__ */ i((e, t) => t.stylize("WeakMap{\u2026}", "special"), "WeakMap"),
  Arguments: dr,
  Int8Array: ce,
  Uint8Array: ce,
  Uint8ClampedArray: ce,
  Int16Array: ce,
  Uint16Array: ce,
  Int32Array: ce,
  Uint32Array: ce,
  Float32Array: ce,
  Float64Array: ce,
  Generator: /* @__PURE__ */ i(() => "", "Generator"),
  DataView: /* @__PURE__ */ i(() => "", "DataView"),
  ArrayBuffer: /* @__PURE__ */ i(() => "", "ArrayBuffer"),
  Error: br,
  HTMLCollection: yt,
  NodeList: yt
}, Rf = /* @__PURE__ */ i((e, t, r) => Xr in e && typeof e[Xr] == "function" ? e[Xr](t) : Le && Le in e && typeof e[Le] == "function" ? e[Le](
t.depth, t) : "inspect" in e && typeof e.inspect == "function" ? e.inspect(t.depth, t) : "constructor" in e && vs.has(e.constructor) ? vs.get(
e.constructor)(e, t) : Fs[r] ? Fs[r](e, t) : "", "inspectCustom"), If = Object.prototype.toString;
function zt(e, t = {}) {
  let r = Qn(t, zt), { customInspect: n } = r, o = e === null ? "null" : typeof e;
  if (o === "object" && (o = If.call(e).slice(8, -1)), o in Ls)
    return Ls[o](e, r);
  if (n && e) {
    let c = Rf(e, r, o);
    if (c)
      return typeof c == "string" ? c : zt(c, r);
  }
  let s = e ? Object.getPrototypeOf(e) : !1;
  return s === Object.prototype || s === null ? Se(e, r) : e && typeof HTMLElement == "function" && e instanceof HTMLElement ? gt(e, r) : "c\
onstructor" in e ? e.constructor !== Object ? hr(e, r) : Se(e, r) : e === Object(e) ? Se(e, r) : r.stylize(String(e), o);
}
i(zt, "inspect");

// ../node_modules/@vitest/utils/dist/chunk-_commonjsHelpers.js
var { AsymmetricMatcher: jf, DOMCollection: Mf, DOMElement: xf, Immutable: vf, ReactElement: Ff, ReactTestComponent: Lf } = ze, Ds = [
  Lf,
  Ff,
  xf,
  Mf,
  vf,
  jf
];
function _e(e, t = 10, { maxLength: r, ...n } = {}) {
  let o = r ?? 1e4, s;
  try {
    s = re(e, {
      maxDepth: t,
      escapeString: !1,
      plugins: Ds,
      ...n
    });
  } catch {
    s = re(e, {
      callToJSON: !1,
      maxDepth: t,
      escapeString: !1,
      plugins: Ds,
      ...n
    });
  }
  return s.length >= o && t > 1 ? _e(e, Math.floor(Math.min(t, Number.MAX_SAFE_INTEGER) / 2), {
    maxLength: r,
    ...n
  }) : s;
}
i(_e, "stringify");
var Df = /%[sdjifoOc%]/g;
function Bs(...e) {
  if (typeof e[0] != "string") {
    let s = [];
    for (let c = 0; c < e.length; c++)
      s.push(Qe(e[c], {
        depth: 0,
        colors: !1
      }));
    return s.join(" ");
  }
  let t = e.length, r = 1, n = e[0], o = String(n).replace(Df, (s) => {
    if (s === "%%")
      return "%";
    if (r >= t)
      return s;
    switch (s) {
      case "%s": {
        let c = e[r++];
        return typeof c == "bigint" ? `${c.toString()}n` : typeof c == "number" && c === 0 && 1 / c < 0 ? "-0" : typeof c == "object" && c !==
        null ? typeof c.toString == "function" && c.toString !== Object.prototype.toString ? c.toString() : Qe(c, {
          depth: 0,
          colors: !1
        }) : String(c);
      }
      case "%d": {
        let c = e[r++];
        return typeof c == "bigint" ? `${c.toString()}n` : Number(c).toString();
      }
      case "%i": {
        let c = e[r++];
        return typeof c == "bigint" ? `${c.toString()}n` : Number.parseInt(String(c)).toString();
      }
      case "%f":
        return Number.parseFloat(String(e[r++])).toString();
      case "%o":
        return Qe(e[r++], {
          showHidden: !0,
          showProxy: !0
        });
      case "%O":
        return Qe(e[r++]);
      case "%c":
        return r++, "";
      case "%j":
        try {
          return JSON.stringify(e[r++]);
        } catch (c) {
          let u = c.message;
          if (u.includes("circular structure") || u.includes("cyclic structures") || u.includes("cyclic object"))
            return "[Circular]";
          throw c;
        }
      default:
        return s;
    }
  });
  for (let s = e[r]; r < t; s = e[++r])
    s === null || typeof s != "object" ? o += ` ${s}` : o += ` ${Qe(s)}`;
  return o;
}
i(Bs, "format");
function Qe(e, t = {}) {
  return t.truncate === 0 && (t.truncate = Number.POSITIVE_INFINITY), zt(e, t);
}
i(Qe, "inspect");
function ks(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
i(ks, "getDefaultExportFromCjs");

// ../node_modules/@vitest/utils/dist/helpers.js
function Bf(e) {
  return e === Object.prototype || e === Function.prototype || e === RegExp.prototype;
}
i(Bf, "isFinalObj");
function Wt(e) {
  return Object.prototype.toString.apply(e).slice(8, -1);
}
i(Wt, "getType");
function kf(e, t) {
  let r = typeof t == "function" ? t : (n) => t.add(n);
  Object.getOwnPropertyNames(e).forEach(r), Object.getOwnPropertySymbols(e).forEach(r);
}
i(kf, "collectOwnProperties");
function Qr(e) {
  let t = /* @__PURE__ */ new Set();
  return Bf(e) ? [] : (kf(e, t), Array.from(t));
}
i(Qr, "getOwnProperties");
var Us = { forceWritable: !1 };
function en(e, t = Us) {
  return Zr(e, /* @__PURE__ */ new WeakMap(), t);
}
i(en, "deepClone");
function Zr(e, t, r = Us) {
  let n, o;
  if (t.has(e))
    return t.get(e);
  if (Array.isArray(e)) {
    for (o = Array.from({ length: n = e.length }), t.set(e, o); n--; )
      o[n] = Zr(e[n], t, r);
    return o;
  }
  if (Object.prototype.toString.call(e) === "[object Object]") {
    o = Object.create(Object.getPrototypeOf(e)), t.set(e, o);
    let s = Qr(e);
    for (let c of s) {
      let u = Object.getOwnPropertyDescriptor(e, c);
      if (!u)
        continue;
      let a = Zr(e[c], t, r);
      r.forceWritable ? Object.defineProperty(o, c, {
        enumerable: u.enumerable,
        configurable: !0,
        writable: !0,
        value: a
      }) : "get" in u ? Object.defineProperty(o, c, {
        ...u,
        get() {
          return a;
        }
      }) : Object.defineProperty(o, c, {
        ...u,
        value: a
      });
    }
    return o;
  }
  return e;
}
i(Zr, "clone");

// ../node_modules/@vitest/utils/dist/diff.js
var Y = -1, q = 1, F = 0, ln = class ln {
  0;
  1;
  constructor(t, r) {
    this[0] = t, this[1] = r;
  }
};
i(ln, "Diff");
var M = ln;
function Uf(e, t) {
  if (!e || !t || e.charAt(0) !== t.charAt(0))
    return 0;
  let r = 0, n = Math.min(e.length, t.length), o = n, s = 0;
  for (; r < o; )
    e.substring(s, o) === t.substring(s, o) ? (r = o, s = r) : n = o, o = Math.floor((n - r) / 2 + r);
  return o;
}
i(Uf, "diff_commonPrefix");
function nc(e, t) {
  if (!e || !t || e.charAt(e.length - 1) !== t.charAt(t.length - 1))
    return 0;
  let r = 0, n = Math.min(e.length, t.length), o = n, s = 0;
  for (; r < o; )
    e.substring(e.length - o, e.length - s) === t.substring(t.length - o, t.length - s) ? (r = o, s = r) : n = o, o = Math.floor((n - r) / 2 +
    r);
  return o;
}
i(nc, "diff_commonSuffix");
function qs(e, t) {
  let r = e.length, n = t.length;
  if (r === 0 || n === 0)
    return 0;
  r > n ? e = e.substring(r - n) : r < n && (t = t.substring(0, r));
  let o = Math.min(r, n);
  if (e === t)
    return o;
  let s = 0, c = 1;
  for (; ; ) {
    let u = e.substring(o - c), a = t.indexOf(u);
    if (a === -1)
      return s;
    c += a, (a === 0 || e.substring(o - c) === t.substring(0, c)) && (s = c, c++);
  }
}
i(qs, "diff_commonOverlap_");
function qf(e) {
  let t = !1, r = [], n = 0, o = null, s = 0, c = 0, u = 0, a = 0, f = 0;
  for (; s < e.length; )
    e[s][0] === F ? (r[n++] = s, c = a, u = f, a = 0, f = 0, o = e[s][1]) : (e[s][0] === q ? a += e[s][1].length : f += e[s][1].length, o &&
    o.length <= Math.max(c, u) && o.length <= Math.max(a, f) && (e.splice(r[n - 1], 0, new M(Y, o)), e[r[n - 1] + 1][0] = q, n--, n--, s = n >
    0 ? r[n - 1] : -1, c = 0, u = 0, a = 0, f = 0, o = null, t = !0)), s++;
  for (t && oc(e), Yf(e), s = 1; s < e.length; ) {
    if (e[s - 1][0] === Y && e[s][0] === q) {
      let y = e[s - 1][1], l = e[s][1], h = qs(y, l), g = qs(l, y);
      h >= g ? (h >= y.length / 2 || h >= l.length / 2) && (e.splice(s, 0, new M(F, l.substring(0, h))), e[s - 1][1] = y.substring(0, y.length -
      h), e[s + 1][1] = l.substring(h), s++) : (g >= y.length / 2 || g >= l.length / 2) && (e.splice(s, 0, new M(F, y.substring(0, g))), e[s -
      1][0] = q, e[s - 1][1] = l.substring(0, l.length - g), e[s + 1][0] = Y, e[s + 1][1] = y.substring(g), s++), s++;
    }
    s++;
  }
}
i(qf, "diff_cleanupSemantic");
var zs = /[^a-z0-9]/i, Ws = /\s/, Ys = /[\r\n]/, zf = /\n\r?\n$/, Wf = /^\r?\n\r?\n/;
function Yf(e) {
  let t = 1;
  for (; t < e.length - 1; ) {
    if (e[t - 1][0] === F && e[t + 1][0] === F) {
      let r = e[t - 1][1], n = e[t][1], o = e[t + 1][1], s = nc(r, n);
      if (s) {
        let y = n.substring(n.length - s);
        r = r.substring(0, r.length - s), n = y + n.substring(0, n.length - s), o = y + o;
      }
      let c = r, u = n, a = o, f = Yt(r, n) + Yt(n, o);
      for (; n.charAt(0) === o.charAt(0); ) {
        r += n.charAt(0), n = n.substring(1) + o.charAt(0), o = o.substring(1);
        let y = Yt(r, n) + Yt(n, o);
        y >= f && (f = y, c = r, u = n, a = o);
      }
      e[t - 1][1] !== c && (c ? e[t - 1][1] = c : (e.splice(t - 1, 1), t--), e[t][1] = u, a ? e[t + 1][1] = a : (e.splice(t + 1, 1), t--));
    }
    t++;
  }
}
i(Yf, "diff_cleanupSemanticLossless");
function oc(e) {
  e.push(new M(F, ""));
  let t = 0, r = 0, n = 0, o = "", s = "", c;
  for (; t < e.length; )
    switch (e[t][0]) {
      case q:
        n++, s += e[t][1], t++;
        break;
      case Y:
        r++, o += e[t][1], t++;
        break;
      case F:
        r + n > 1 ? (r !== 0 && n !== 0 && (c = Uf(s, o), c !== 0 && (t - r - n > 0 && e[t - r - n - 1][0] === F ? e[t - r - n - 1][1] += s.
        substring(0, c) : (e.splice(0, 0, new M(F, s.substring(0, c))), t++), s = s.substring(c), o = o.substring(c)), c = nc(s, o), c !== 0 &&
        (e[t][1] = s.substring(s.length - c) + e[t][1], s = s.substring(0, s.length - c), o = o.substring(0, o.length - c))), t -= r + n, e.
        splice(t, r + n), o.length && (e.splice(t, 0, new M(Y, o)), t++), s.length && (e.splice(t, 0, new M(q, s)), t++), t++) : t !== 0 && e[t -
        1][0] === F ? (e[t - 1][1] += e[t][1], e.splice(t, 1)) : t++, n = 0, r = 0, o = "", s = "";
        break;
    }
  e[e.length - 1][1] === "" && e.pop();
  let u = !1;
  for (t = 1; t < e.length - 1; )
    e[t - 1][0] === F && e[t + 1][0] === F && (e[t][1].substring(e[t][1].length - e[t - 1][1].length) === e[t - 1][1] ? (e[t][1] = e[t - 1][1] +
    e[t][1].substring(0, e[t][1].length - e[t - 1][1].length), e[t + 1][1] = e[t - 1][1] + e[t + 1][1], e.splice(t - 1, 1), u = !0) : e[t][1].
    substring(0, e[t + 1][1].length) === e[t + 1][1] && (e[t - 1][1] += e[t + 1][1], e[t][1] = e[t][1].substring(e[t + 1][1].length) + e[t +
    1][1], e.splice(t + 1, 1), u = !0)), t++;
  u && oc(e);
}
i(oc, "diff_cleanupMerge");
function Yt(e, t) {
  if (!e || !t)
    return 6;
  let r = e.charAt(e.length - 1), n = t.charAt(0), o = r.match(zs), s = n.match(zs), c = o && r.match(Ws), u = s && n.match(Ws), a = c && r.
  match(Ys), f = u && n.match(Ys), y = a && e.match(zf), l = f && t.match(Wf);
  return y || l ? 5 : a || f ? 4 : o && !c && u ? 3 : c || u ? 2 : o || s ? 1 : 0;
}
i(Yt, "diff_cleanupSemanticScore_");
var ic = "Compared values have no visual difference.", Gf = "Compared values serialize to the same structure.\nPrinting internal object struc\
ture without calling `toJSON` instead.", Gt = {}, Gs;
function Vf() {
  if (Gs) return Gt;
  Gs = 1, Object.defineProperty(Gt, "__esModule", {
    value: !0
  }), Gt.default = h;
  let e = "diff-sequences", t = 0, r = /* @__PURE__ */ i((g, m, p, d, S) => {
    let A = 0;
    for (; g < m && p < d && S(g, p); )
      g += 1, p += 1, A += 1;
    return A;
  }, "countCommonItemsF"), n = /* @__PURE__ */ i((g, m, p, d, S) => {
    let A = 0;
    for (; g <= m && p <= d && S(m, d); )
      m -= 1, d -= 1, A += 1;
    return A;
  }, "countCommonItemsR"), o = /* @__PURE__ */ i((g, m, p, d, S, A, T) => {
    let b = 0, E = -g, P = A[b], O = P;
    A[b] += r(
      P + 1,
      m,
      d + P - E + 1,
      p,
      S
    );
    let N = g < T ? g : T;
    for (b += 1, E += 2; b <= N; b += 1, E += 2) {
      if (b !== g && O < A[b])
        P = A[b];
      else if (P = O + 1, m <= P)
        return b - 1;
      O = A[b], A[b] = P + r(P + 1, m, d + P - E + 1, p, S);
    }
    return T;
  }, "extendPathsF"), s = /* @__PURE__ */ i((g, m, p, d, S, A, T) => {
    let b = 0, E = g, P = A[b], O = P;
    A[b] -= n(
      m,
      P - 1,
      p,
      d + P - E - 1,
      S
    );
    let N = g < T ? g : T;
    for (b += 1, E -= 2; b <= N; b += 1, E -= 2) {
      if (b !== g && A[b] < O)
        P = A[b];
      else if (P = O - 1, P < m)
        return b - 1;
      O = A[b], A[b] = P - n(
        m,
        P - 1,
        p,
        d + P - E - 1,
        S
      );
    }
    return T;
  }, "extendPathsR"), c = /* @__PURE__ */ i((g, m, p, d, S, A, T, b, E, P, O) => {
    let N = d - m, Z = p - m, v = S - d - Z, z = -v - (g - 1), Q = -v + (g - 1), G = t, x = g < b ? g : b;
    for (let L = 0, D = -g; L <= x; L += 1, D += 2) {
      let ee = L === 0 || L !== g && G < T[L], k = ee ? T[L] : G, K = ee ? k : k + 1, le = N + K - D, J = r(
        K + 1,
        p,
        le + 1,
        S,
        A
      ), X = K + J;
      if (G = T[L], T[L] = X, z <= D && D <= Q) {
        let pe = (g - 1 - (D + v)) / 2;
        if (pe <= P && E[pe] - 1 <= X) {
          let te = N + k - (ee ? D + 1 : D - 1), H = n(
            m,
            k,
            d,
            te,
            A
          ), fe = k - H, Te = te - H, me = fe + 1, ke = Te + 1;
          O.nChangePreceding = g - 1, g - 1 === me + ke - m - d ? (O.aEndPreceding = m, O.bEndPreceding = d) : (O.aEndPreceding = me, O.bEndPreceding =
          ke), O.nCommonPreceding = H, H !== 0 && (O.aCommonPreceding = me, O.bCommonPreceding = ke), O.nCommonFollowing = J, J !== 0 && (O.
          aCommonFollowing = K + 1, O.bCommonFollowing = le + 1);
          let et = X + 1, tt = le + J + 1;
          return O.nChangeFollowing = g - 1, g - 1 === p + S - et - tt ? (O.aStartFollowing = p, O.bStartFollowing = S) : (O.aStartFollowing =
          et, O.bStartFollowing = tt), !0;
        }
      }
    }
    return !1;
  }, "extendOverlappablePathsF"), u = /* @__PURE__ */ i((g, m, p, d, S, A, T, b, E, P, O) => {
    let N = S - p, Z = p - m, v = S - d - Z, z = v - g, Q = v + g, G = t, x = g < P ? g : P;
    for (let L = 0, D = g; L <= x; L += 1, D -= 2) {
      let ee = L === 0 || L !== g && E[L] < G, k = ee ? E[L] : G, K = ee ? k : k - 1, le = N + K - D, J = n(
        m,
        K - 1,
        d,
        le - 1,
        A
      ), X = K - J;
      if (G = E[L], E[L] = X, z <= D && D <= Q) {
        let pe = (g + (D - v)) / 2;
        if (pe <= b && X - 1 <= T[pe]) {
          let te = le - J;
          if (O.nChangePreceding = g, g === X + te - m - d ? (O.aEndPreceding = m, O.bEndPreceding = d) : (O.aEndPreceding = X, O.bEndPreceding =
          te), O.nCommonPreceding = J, J !== 0 && (O.aCommonPreceding = X, O.bCommonPreceding = te), O.nChangeFollowing = g - 1, g === 1)
            O.nCommonFollowing = 0, O.aStartFollowing = p, O.bStartFollowing = S;
          else {
            let H = N + k - (ee ? D - 1 : D + 1), fe = r(
              k,
              p,
              H,
              S,
              A
            );
            O.nCommonFollowing = fe, fe !== 0 && (O.aCommonFollowing = k, O.bCommonFollowing = H);
            let Te = k + fe, me = H + fe;
            g - 1 === p + S - Te - me ? (O.aStartFollowing = p, O.bStartFollowing = S) : (O.aStartFollowing = Te, O.bStartFollowing = me);
          }
          return !0;
        }
      }
    }
    return !1;
  }, "extendOverlappablePathsR"), a = /* @__PURE__ */ i((g, m, p, d, S, A, T, b, E) => {
    let P = d - m, O = S - p, N = p - m, Z = S - d, oe = Z - N, v = N, z = N;
    if (T[0] = m - 1, b[0] = p, oe % 2 === 0) {
      let Q = (g || oe) / 2, G = (N + Z) / 2;
      for (let x = 1; x <= G; x += 1)
        if (v = o(x, p, S, P, A, T, v), x < Q)
          z = s(x, m, d, O, A, b, z);
        else if (
          // If a reverse path overlaps a forward path in the same diagonal,
          // return a division of the index intervals at the middle change.
          u(
            x,
            m,
            p,
            d,
            S,
            A,
            T,
            v,
            b,
            z,
            E
          )
        )
          return;
    } else {
      let Q = ((g || oe) + 1) / 2, G = (N + Z + 1) / 2, x = 1;
      for (v = o(x, p, S, P, A, T, v), x += 1; x <= G; x += 1)
        if (z = s(
          x - 1,
          m,
          d,
          O,
          A,
          b,
          z
        ), x < Q)
          v = o(x, p, S, P, A, T, v);
        else if (
          // If a forward path overlaps a reverse path in the same diagonal,
          // return a division of the index intervals at the middle change.
          c(
            x,
            m,
            p,
            d,
            S,
            A,
            T,
            v,
            b,
            z,
            E
          )
        )
          return;
    }
    throw new Error(
      `${e}: no overlap aStart=${m} aEnd=${p} bStart=${d} bEnd=${S}`
    );
  }, "divide"), f = /* @__PURE__ */ i((g, m, p, d, S, A, T, b, E, P) => {
    if (S - d < p - m) {
      if (A = !A, A && T.length === 1) {
        let { foundSubsequence: X, isCommon: pe } = T[0];
        T[1] = {
          foundSubsequence: /* @__PURE__ */ i((te, H, fe) => {
            X(te, fe, H);
          }, "foundSubsequence"),
          isCommon: /* @__PURE__ */ i((te, H) => pe(H, te), "isCommon")
        };
      }
      let le = m, J = p;
      m = d, p = S, d = le, S = J;
    }
    let { foundSubsequence: O, isCommon: N } = T[A ? 1 : 0];
    a(
      g,
      m,
      p,
      d,
      S,
      N,
      b,
      E,
      P
    );
    let {
      nChangePreceding: Z,
      aEndPreceding: oe,
      bEndPreceding: v,
      nCommonPreceding: z,
      aCommonPreceding: Q,
      bCommonPreceding: G,
      nCommonFollowing: x,
      aCommonFollowing: L,
      bCommonFollowing: D,
      nChangeFollowing: ee,
      aStartFollowing: k,
      bStartFollowing: K
    } = P;
    m < oe && d < v && f(
      Z,
      m,
      oe,
      d,
      v,
      A,
      T,
      b,
      E,
      P
    ), z !== 0 && O(z, Q, G), x !== 0 && O(x, L, D), k < p && K < S && f(
      ee,
      k,
      p,
      K,
      S,
      A,
      T,
      b,
      E,
      P
    );
  }, "findSubsequences"), y = /* @__PURE__ */ i((g, m) => {
    if (typeof m != "number")
      throw new TypeError(`${e}: ${g} typeof ${typeof m} is not a number`);
    if (!Number.isSafeInteger(m))
      throw new RangeError(`${e}: ${g} value ${m} is not a safe integer`);
    if (m < 0)
      throw new RangeError(`${e}: ${g} value ${m} is a negative integer`);
  }, "validateLength"), l = /* @__PURE__ */ i((g, m) => {
    let p = typeof m;
    if (p !== "function")
      throw new TypeError(`${e}: ${g} typeof ${p} is not a function`);
  }, "validateCallback");
  function h(g, m, p, d) {
    y("aLength", g), y("bLength", m), l("isCommon", p), l("foundSubsequence", d);
    let S = r(0, g, 0, m, p);
    if (S !== 0 && d(S, 0, 0), g !== S || m !== S) {
      let A = S, T = S, b = n(
        A,
        g - 1,
        T,
        m - 1,
        p
      ), E = g - b, P = m - b, O = S + b;
      g !== O && m !== O && f(
        0,
        A,
        E,
        T,
        P,
        !1,
        [
          {
            foundSubsequence: d,
            isCommon: p
          }
        ],
        [t],
        [t],
        {
          aCommonFollowing: t,
          aCommonPreceding: t,
          aEndPreceding: t,
          aStartFollowing: t,
          bCommonFollowing: t,
          bCommonPreceding: t,
          bEndPreceding: t,
          bStartFollowing: t,
          nChangeFollowing: t,
          nChangePreceding: t,
          nCommonFollowing: t,
          nCommonPreceding: t
        }
      ), b !== 0 && d(b, E, P);
    }
  }
  return i(h, "diffSequence"), Gt;
}
i(Vf, "requireBuild");
var Hf = Vf(), sc = /* @__PURE__ */ ks(Hf);
function Kf(e, t) {
  return e.replace(/\s+$/, (r) => t(r));
}
i(Kf, "formatTrailingSpaces");
function an(e, t, r, n, o, s) {
  return e.length !== 0 ? r(`${n} ${Kf(e, o)}`) : n !== " " ? r(n) : t && s.length !== 0 ? r(`${n} ${s}`) : "";
}
i(an, "printDiffLine");
function cc(e, t, { aColor: r, aIndicator: n, changeLineTrailingSpaceColor: o, emptyFirstOrLastLinePlaceholder: s }) {
  return an(e, t, r, n, o, s);
}
i(cc, "printDeleteLine");
function ac(e, t, { bColor: r, bIndicator: n, changeLineTrailingSpaceColor: o, emptyFirstOrLastLinePlaceholder: s }) {
  return an(e, t, r, n, o, s);
}
i(ac, "printInsertLine");
function uc(e, t, { commonColor: r, commonIndicator: n, commonLineTrailingSpaceColor: o, emptyFirstOrLastLinePlaceholder: s }) {
  return an(e, t, r, n, o, s);
}
i(uc, "printCommonLine");
function Vs(e, t, r, n, { patchColor: o }) {
  return o(`@@ -${e + 1},${t - e} +${r + 1},${n - r} @@`);
}
i(Vs, "createPatchMark");
function Jf(e, t) {
  let r = e.length, n = t.contextLines, o = n + n, s = r, c = !1, u = 0, a = 0;
  for (; a !== r; ) {
    let b = a;
    for (; a !== r && e[a][0] === F; )
      a += 1;
    if (b !== a)
      if (b === 0)
        a > n && (s -= a - n, c = !0);
      else if (a === r) {
        let E = a - b;
        E > n && (s -= E - n, c = !0);
      } else {
        let E = a - b;
        E > o && (s -= E - o, u += 1);
      }
    for (; a !== r && e[a][0] !== F; )
      a += 1;
  }
  let f = u !== 0 || c;
  u !== 0 ? s += u + 1 : c && (s += 1);
  let y = s - 1, l = [], h = 0;
  f && l.push("");
  let g = 0, m = 0, p = 0, d = 0, S = /* @__PURE__ */ i((b) => {
    let E = l.length;
    l.push(uc(b, E === 0 || E === y, t)), p += 1, d += 1;
  }, "pushCommonLine"), A = /* @__PURE__ */ i((b) => {
    let E = l.length;
    l.push(cc(b, E === 0 || E === y, t)), p += 1;
  }, "pushDeleteLine"), T = /* @__PURE__ */ i((b) => {
    let E = l.length;
    l.push(ac(b, E === 0 || E === y, t)), d += 1;
  }, "pushInsertLine");
  for (a = 0; a !== r; ) {
    let b = a;
    for (; a !== r && e[a][0] === F; )
      a += 1;
    if (b !== a)
      if (b === 0) {
        a > n && (b = a - n, g = b, m = b, p = g, d = m);
        for (let E = b; E !== a; E += 1)
          S(e[E][1]);
      } else if (a === r) {
        let E = a - b > n ? b + n : a;
        for (let P = b; P !== E; P += 1)
          S(e[P][1]);
      } else {
        let E = a - b;
        if (E > o) {
          let P = b + n;
          for (let N = b; N !== P; N += 1)
            S(e[N][1]);
          l[h] = Vs(g, p, m, d, t), h = l.length, l.push("");
          let O = E - o;
          g = p + O, m = d + O, p = g, d = m;
          for (let N = a - n; N !== a; N += 1)
            S(e[N][1]);
        } else
          for (let P = b; P !== a; P += 1)
            S(e[P][1]);
      }
    for (; a !== r && e[a][0] === Y; )
      A(e[a][1]), a += 1;
    for (; a !== r && e[a][0] === q; )
      T(e[a][1]), a += 1;
  }
  return f && (l[h] = Vs(g, p, m, d, t)), l.join(`
`);
}
i(Jf, "joinAlignedDiffsNoExpand");
function Xf(e, t) {
  return e.map((r, n, o) => {
    let s = r[1], c = n === 0 || n === o.length - 1;
    switch (r[0]) {
      case Y:
        return cc(s, c, t);
      case q:
        return ac(s, c, t);
      default:
        return uc(s, c, t);
    }
  }).join(`
`);
}
i(Xf, "joinAlignedDiffsExpand");
var tn = /* @__PURE__ */ i((e) => e, "noColor"), lc = 5, Zf = 0;
function Qf() {
  return {
    aAnnotation: "Expected",
    aColor: ie.green,
    aIndicator: "-",
    bAnnotation: "Received",
    bColor: ie.red,
    bIndicator: "+",
    changeColor: ie.inverse,
    changeLineTrailingSpaceColor: tn,
    commonColor: ie.dim,
    commonIndicator: " ",
    commonLineTrailingSpaceColor: tn,
    compareKeys: void 0,
    contextLines: lc,
    emptyFirstOrLastLinePlaceholder: "",
    expand: !1,
    includeChangeCounts: !1,
    omitAnnotationLines: !1,
    patchColor: ie.yellow,
    printBasicPrototype: !1,
    truncateThreshold: Zf,
    truncateAnnotation: "... Diff result is truncated",
    truncateAnnotationColor: tn
  };
}
i(Qf, "getDefaultOptions");
function ep(e) {
  return e && typeof e == "function" ? e : void 0;
}
i(ep, "getCompareKeys");
function tp(e) {
  return typeof e == "number" && Number.isSafeInteger(e) && e >= 0 ? e : lc;
}
i(tp, "getContextLines");
function we(e = {}) {
  return {
    ...Qf(),
    ...e,
    compareKeys: ep(e.compareKeys),
    contextLines: tp(e.contextLines)
  };
}
i(we, "normalizeDiffOptions");
function De(e) {
  return e.length === 1 && e[0].length === 0;
}
i(De, "isEmptyString");
function rp(e) {
  let t = 0, r = 0;
  return e.forEach((n) => {
    switch (n[0]) {
      case Y:
        t += 1;
        break;
      case q:
        r += 1;
        break;
    }
  }), {
    a: t,
    b: r
  };
}
i(rp, "countChanges");
function np({ aAnnotation: e, aColor: t, aIndicator: r, bAnnotation: n, bColor: o, bIndicator: s, includeChangeCounts: c, omitAnnotationLines: u }, a) {
  if (u)
    return "";
  let f = "", y = "";
  if (c) {
    let g = String(a.a), m = String(a.b), p = n.length - e.length, d = " ".repeat(Math.max(0, p)), S = " ".repeat(Math.max(0, -p)), A = m.length -
    g.length, T = " ".repeat(Math.max(0, A)), b = " ".repeat(Math.max(0, -A));
    f = `${d}  ${r} ${T}${g}`, y = `${S}  ${s} ${b}${m}`;
  }
  let l = `${r} ${e}${f}`, h = `${s} ${n}${y}`;
  return `${t(l)}
${o(h)}

`;
}
i(np, "printAnnotation");
function un(e, t, r) {
  return np(r, rp(e)) + (r.expand ? Xf(e, r) : Jf(e, r)) + (t ? r.truncateAnnotationColor(`
${r.truncateAnnotation}`) : "");
}
i(un, "printDiffLines");
function Ht(e, t, r) {
  let n = we(r), [o, s] = fc(De(e) ? [] : e, De(t) ? [] : t, n);
  return un(o, s, n);
}
i(Ht, "diffLinesUnified");
function op(e, t, r, n, o) {
  if (De(e) && De(r) && (e = [], r = []), De(t) && De(n) && (t = [], n = []), e.length !== r.length || t.length !== n.length)
    return Ht(e, t, o);
  let [s, c] = fc(r, n, o), u = 0, a = 0;
  return s.forEach((f) => {
    switch (f[0]) {
      case Y:
        f[1] = e[u], u += 1;
        break;
      case q:
        f[1] = t[a], a += 1;
        break;
      default:
        f[1] = t[a], u += 1, a += 1;
    }
  }), un(s, c, we(o));
}
i(op, "diffLinesUnified2");
function fc(e, t, r) {
  let n = r?.truncateThreshold ?? !1, o = Math.max(Math.floor(r?.truncateThreshold ?? 0), 0), s = n ? Math.min(e.length, o) : e.length, c = n ?
  Math.min(t.length, o) : t.length, u = s !== e.length || c !== t.length, a = /* @__PURE__ */ i((g, m) => e[g] === t[m], "isCommon"), f = [],
  y = 0, l = 0;
  for (sc(s, c, a, /* @__PURE__ */ i((g, m, p) => {
    for (; y !== m; y += 1)
      f.push(new M(Y, e[y]));
    for (; l !== p; l += 1)
      f.push(new M(q, t[l]));
    for (; g !== 0; g -= 1, y += 1, l += 1)
      f.push(new M(F, t[l]));
  }, "foundSubsequence")); y !== s; y += 1)
    f.push(new M(Y, e[y]));
  for (; l !== c; l += 1)
    f.push(new M(q, t[l]));
  return [f, u];
}
i(fc, "diffLinesRaw");
function Hs(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  if (Array.isArray(e))
    return "array";
  if (typeof e == "boolean")
    return "boolean";
  if (typeof e == "function")
    return "function";
  if (typeof e == "number")
    return "number";
  if (typeof e == "string")
    return "string";
  if (typeof e == "bigint")
    return "bigint";
  if (typeof e == "object") {
    if (e != null) {
      if (e.constructor === RegExp)
        return "regexp";
      if (e.constructor === Map)
        return "map";
      if (e.constructor === Set)
        return "set";
      if (e.constructor === Date)
        return "date";
    }
    return "object";
  } else if (typeof e == "symbol")
    return "symbol";
  throw new Error(`value of unknown type: ${e}`);
}
i(Hs, "getType");
function Ks(e) {
  return e.includes(`\r
`) ? `\r
` : `
`;
}
i(Ks, "getNewLineSymbol");
function ip(e, t, r) {
  let n = r?.truncateThreshold ?? !1, o = Math.max(Math.floor(r?.truncateThreshold ?? 0), 0), s = e.length, c = t.length;
  if (n) {
    let g = e.includes(`
`), m = t.includes(`
`), p = Ks(e), d = Ks(t), S = g ? `${e.split(p, o).join(p)}
` : e, A = m ? `${t.split(d, o).join(d)}
` : t;
    s = S.length, c = A.length;
  }
  let u = s !== e.length || c !== t.length, a = /* @__PURE__ */ i((g, m) => e[g] === t[m], "isCommon"), f = 0, y = 0, l = [];
  return sc(s, c, a, /* @__PURE__ */ i((g, m, p) => {
    f !== m && l.push(new M(Y, e.slice(f, m))), y !== p && l.push(new M(q, t.slice(y, p))), f = m + g, y = p + g, l.push(new M(F, t.slice(p,
    y)));
  }, "foundSubsequence")), f !== s && l.push(new M(Y, e.slice(f))), y !== c && l.push(new M(q, t.slice(y))), [l, u];
}
i(ip, "diffStrings");
function sp(e, t, r) {
  return t.reduce((n, o) => n + (o[0] === F ? o[1] : o[0] === e && o[1].length !== 0 ? r(o[1]) : ""), "");
}
i(sp, "concatenateRelevantDiffs");
var fn = class fn {
  op;
  line;
  lines;
  changeColor;
  constructor(t, r) {
    this.op = t, this.line = [], this.lines = [], this.changeColor = r;
  }
  pushSubstring(t) {
    this.pushDiff(new M(this.op, t));
  }
  pushLine() {
    this.lines.push(this.line.length !== 1 ? new M(this.op, sp(this.op, this.line, this.changeColor)) : this.line[0][0] === this.op ? this.line[0] :
    new M(this.op, this.line[0][1])), this.line.length = 0;
  }
  isLineEmpty() {
    return this.line.length === 0;
  }
  pushDiff(t) {
    this.line.push(t);
  }
  align(t) {
    let r = t[1];
    if (r.includes(`
`)) {
      let n = r.split(`
`), o = n.length - 1;
      n.forEach((s, c) => {
        c < o ? (this.pushSubstring(s), this.pushLine()) : s.length !== 0 && this.pushSubstring(s);
      });
    } else
      this.pushDiff(t);
  }
  moveLinesTo(t) {
    this.isLineEmpty() || this.pushLine(), t.push(...this.lines), this.lines.length = 0;
  }
};
i(fn, "ChangeBuffer");
var Vt = fn, pn = class pn {
  deleteBuffer;
  insertBuffer;
  lines;
  constructor(t, r) {
    this.deleteBuffer = t, this.insertBuffer = r, this.lines = [];
  }
  pushDiffCommonLine(t) {
    this.lines.push(t);
  }
  pushDiffChangeLines(t) {
    let r = t[1].length === 0;
    (!r || this.deleteBuffer.isLineEmpty()) && this.deleteBuffer.pushDiff(t), (!r || this.insertBuffer.isLineEmpty()) && this.insertBuffer.pushDiff(
    t);
  }
  flushChangeLines() {
    this.deleteBuffer.moveLinesTo(this.lines), this.insertBuffer.moveLinesTo(this.lines);
  }
  align(t) {
    let r = t[0], n = t[1];
    if (n.includes(`
`)) {
      let o = n.split(`
`), s = o.length - 1;
      o.forEach((c, u) => {
        if (u === 0) {
          let a = new M(r, c);
          this.deleteBuffer.isLineEmpty() && this.insertBuffer.isLineEmpty() ? (this.flushChangeLines(), this.pushDiffCommonLine(a)) : (this.
          pushDiffChangeLines(a), this.flushChangeLines());
        } else u < s ? this.pushDiffCommonLine(new M(r, c)) : c.length !== 0 && this.pushDiffChangeLines(new M(r, c));
      });
    } else
      this.pushDiffChangeLines(t);
  }
  getLines() {
    return this.flushChangeLines(), this.lines;
  }
};
i(pn, "CommonBuffer");
var nn = pn;
function cp(e, t) {
  let r = new Vt(Y, t), n = new Vt(q, t), o = new nn(r, n);
  return e.forEach((s) => {
    switch (s[0]) {
      case Y:
        r.align(s);
        break;
      case q:
        n.align(s);
        break;
      default:
        o.align(s);
    }
  }), o.getLines();
}
i(cp, "getAlignedDiffs");
function ap(e, t) {
  if (t) {
    let r = e.length - 1;
    return e.some((n, o) => n[0] === F && (o !== r || n[1] !== `
`));
  }
  return e.some((r) => r[0] === F);
}
i(ap, "hasCommonDiff");
function up(e, t, r) {
  if (e !== t && e.length !== 0 && t.length !== 0) {
    let n = e.includes(`
`) || t.includes(`
`), [o, s] = pc(n ? `${e}
` : e, n ? `${t}
` : t, !0, r);
    if (ap(o, n)) {
      let c = we(r), u = cp(o, c.changeColor);
      return un(u, s, c);
    }
  }
  return Ht(e.split(`
`), t.split(`
`), r);
}
i(up, "diffStringsUnified");
function pc(e, t, r, n) {
  let [o, s] = ip(e, t, n);
  return r && qf(o), [o, s];
}
i(pc, "diffStringsRaw");
function on(e, t) {
  let { commonColor: r } = we(t);
  return r(e);
}
i(on, "getCommonMessage");
var { AsymmetricMatcher: lp, DOMCollection: fp, DOMElement: pp, Immutable: yp, ReactElement: gp, ReactTestComponent: mp } = ze, yc = [
  mp,
  gp,
  pp,
  fp,
  yp,
  lp,
  ze.Error
], sn = {
  maxDepth: 20,
  plugins: yc
}, gc = {
  callToJSON: !1,
  maxDepth: 8,
  plugins: yc
};
function hp(e, t, r) {
  if (Object.is(e, t))
    return "";
  let n = Hs(e), o = n, s = !1;
  if (n === "object" && typeof e.asymmetricMatch == "function") {
    if (e.$$typeof !== Symbol.for("jest.asymmetricMatcher") || typeof e.getExpectedType != "function")
      return;
    o = e.getExpectedType(), s = o === "string";
  }
  if (o !== Hs(t)) {
    let d = function(T) {
      return T.length <= p ? T : `${T.slice(0, p)}...`;
    };
    i(d, "truncate");
    let { aAnnotation: c, aColor: u, aIndicator: a, bAnnotation: f, bColor: y, bIndicator: l } = we(r), h = cn(gc, r), g = re(e, h), m = re(
    t, h), p = 1e5;
    g = d(g), m = d(m);
    let S = `${u(`${a} ${c}:`)} 
${g}`, A = `${y(`${l} ${f}:`)} 
${m}`;
    return `${S}

${A}`;
  }
  if (!s)
    switch (n) {
      case "string":
        return Ht(e.split(`
`), t.split(`
`), r);
      case "boolean":
      case "number":
        return dp(e, t, r);
      case "map":
        return rn(Js(e), Js(t), r);
      case "set":
        return rn(Xs(e), Xs(t), r);
      default:
        return rn(e, t, r);
    }
}
i(hp, "diff");
function dp(e, t, r) {
  let n = re(e, sn), o = re(t, sn);
  return n === o ? "" : Ht(n.split(`
`), o.split(`
`), r);
}
i(dp, "comparePrimitive");
function Js(e) {
  return new Map(Array.from(e.entries()).sort());
}
i(Js, "sortMap");
function Xs(e) {
  return new Set(Array.from(e.values()).sort());
}
i(Xs, "sortSet");
function rn(e, t, r) {
  let n, o = !1;
  try {
    let c = cn(sn, r);
    n = Zs(e, t, c, r);
  } catch {
    o = !0;
  }
  let s = on(ic, r);
  if (n === void 0 || n === s) {
    let c = cn(gc, r);
    n = Zs(e, t, c, r), n !== s && !o && (n = `${on(Gf, r)}

${n}`);
  }
  return n;
}
i(rn, "compareObjects");
function cn(e, t) {
  let { compareKeys: r, printBasicPrototype: n, maxDepth: o } = we(t);
  return {
    ...e,
    compareKeys: r,
    printBasicPrototype: n,
    maxDepth: o ?? e.maxDepth
  };
}
i(cn, "getFormatOptions");
function Zs(e, t, r, n) {
  let o = {
    ...r,
    indent: 0
  }, s = re(e, o), c = re(t, o);
  if (s === c)
    return on(ic, n);
  {
    let u = re(e, r), a = re(t, r);
    return op(u.split(`
`), a.split(`
`), s.split(`
`), c.split(`
`), n);
  }
}
i(Zs, "getObjectsDifference");
var Qs = 2e4;
function ec(e) {
  return Wt(e) === "Object" && typeof e.asymmetricMatch == "function";
}
i(ec, "isAsymmetricMatcher");
function tc(e, t) {
  let r = Wt(e), n = Wt(t);
  return r === n && (r === "Object" || r === "Array");
}
i(tc, "isReplaceable");
function mc(e, t, r) {
  let { aAnnotation: n, bAnnotation: o } = we(r);
  if (typeof t == "string" && typeof e == "string" && t.length > 0 && e.length > 0 && t.length <= Qs && e.length <= Qs && t !== e) {
    if (t.includes(`
`) || e.includes(`
`))
      return up(t, e, r);
    let [y] = pc(t, e, !0), l = y.some((p) => p[0] === F), h = bp(n, o), g = h(n) + Ap(rc(y, Y, l)), m = h(o) + Ep(rc(y, q, l));
    return `${g}
${m}`;
  }
  let s = en(t, { forceWritable: !0 }), c = en(e, { forceWritable: !0 }), { replacedExpected: u, replacedActual: a } = hc(c, s);
  return hp(u, a, r);
}
i(mc, "printDiffOrStringify");
function hc(e, t, r = /* @__PURE__ */ new WeakSet(), n = /* @__PURE__ */ new WeakSet()) {
  return e instanceof Error && t instanceof Error && typeof e.cause < "u" && typeof t.cause > "u" ? (delete e.cause, {
    replacedActual: e,
    replacedExpected: t
  }) : tc(e, t) ? r.has(e) || n.has(t) ? {
    replacedActual: e,
    replacedExpected: t
  } : (r.add(e), n.add(t), Qr(t).forEach((o) => {
    let s = t[o], c = e[o];
    if (ec(s))
      s.asymmetricMatch(c) && (e[o] = s);
    else if (ec(c))
      c.asymmetricMatch(s) && (t[o] = c);
    else if (tc(c, s)) {
      let u = hc(c, s, r, n);
      e[o] = u.replacedActual, t[o] = u.replacedExpected;
    }
  }), {
    replacedActual: e,
    replacedExpected: t
  }) : {
    replacedActual: e,
    replacedExpected: t
  };
}
i(hc, "replaceAsymmetricMatcher");
function bp(...e) {
  let t = e.reduce((r, n) => n.length > r ? n.length : r, 0);
  return (r) => `${r}: ${" ".repeat(t - r.length)}`;
}
i(bp, "getLabelPrinter");
var Sp = "\xB7";
function dc(e) {
  return e.replace(/\s+$/gm, (t) => Sp.repeat(t.length));
}
i(dc, "replaceTrailingSpaces");
function Ep(e) {
  return ie.red(dc(_e(e)));
}
i(Ep, "printReceived");
function Ap(e) {
  return ie.green(dc(_e(e)));
}
i(Ap, "printExpected");
function rc(e, t, r) {
  return e.reduce((n, o) => n + (o[0] === F ? o[1] : o[0] === t ? r ? ie.inverse(o[1]) : o[1] : ""), "");
}
i(rc, "getCommonAndChangedSubstrings");

// ../node_modules/@vitest/utils/dist/error.js
var Op = "@@__IMMUTABLE_RECORD__@@", _p = "@@__IMMUTABLE_ITERABLE__@@";
function wp(e) {
  return e && (e[_p] || e[Op]);
}
i(wp, "isImmutable");
var Tp = Object.getPrototypeOf({});
function bc(e) {
  return e instanceof Error ? `<unserializable>: ${e.message}` : typeof e == "string" ? `<unserializable>: ${e}` : "<unserializable>";
}
i(bc, "getUnserializableMessage");
function Be(e, t = /* @__PURE__ */ new WeakMap()) {
  if (!e || typeof e == "string")
    return e;
  if (typeof e == "function")
    return `Function<${e.name || "anonymous"}>`;
  if (typeof e == "symbol")
    return e.toString();
  if (typeof e != "object")
    return e;
  if (wp(e))
    return Be(e.toJSON(), t);
  if (e instanceof Promise || e.constructor && e.constructor.prototype === "AsyncFunction")
    return "Promise";
  if (typeof Element < "u" && e instanceof Element)
    return e.tagName;
  if (typeof e.asymmetricMatch == "function")
    return `${e.toString()} ${Bs(e.sample)}`;
  if (typeof e.toJSON == "function")
    return Be(e.toJSON(), t);
  if (t.has(e))
    return t.get(e);
  if (Array.isArray(e)) {
    let r = new Array(e.length);
    return t.set(e, r), e.forEach((n, o) => {
      try {
        r[o] = Be(n, t);
      } catch (s) {
        r[o] = bc(s);
      }
    }), r;
  } else {
    let r = /* @__PURE__ */ Object.create(null);
    t.set(e, r);
    let n = e;
    for (; n && n !== Tp; )
      Object.getOwnPropertyNames(n).forEach((o) => {
        if (!(o in r))
          try {
            r[o] = Be(e[o], t);
          } catch (s) {
            delete r[o], r[o] = bc(s);
          }
      }), n = Object.getPrototypeOf(n);
    return r;
  }
}
i(Be, "serializeValue");
function Pp(e) {
  return e.replace(/__(vite_ssr_import|vi_import)_\d+__\./g, "");
}
i(Pp, "normalizeErrorMessage");
function yn(e, t, r = /* @__PURE__ */ new WeakSet()) {
  if (!e || typeof e != "object")
    return { message: String(e) };
  let n = e;
  n.stack && (n.stackStr = String(n.stack)), n.name && (n.nameStr = String(n.name)), (n.showDiff || n.showDiff === void 0 && n.expected !== void 0 &&
  n.actual !== void 0) && (n.diff = mc(n.actual, n.expected, {
    ...t,
    ...n.diffOptions
  })), typeof n.expected != "string" && (n.expected = _e(n.expected, 10)), typeof n.actual != "string" && (n.actual = _e(n.actual, 10));
  try {
    typeof n.message == "string" && (n.message = Pp(n.message));
  } catch {
  }
  try {
    !r.has(n) && typeof n.cause == "object" && (r.add(n), n.cause = yn(n.cause, t, r));
  } catch {
  }
  try {
    return Be(n);
  } catch (o) {
    return Be(new Error(`Failed to fully serialize error: ${o?.message}
Inner error message: ${n?.message}`));
  }
}
i(yn, "processError");

// src/instrumenter/EVENTS.ts
var ue = {
  CALL: "storybook/instrumenter/call",
  SYNC: "storybook/instrumenter/sync",
  START: "storybook/instrumenter/start",
  BACK: "storybook/instrumenter/back",
  GOTO: "storybook/instrumenter/goto",
  NEXT: "storybook/instrumenter/next",
  END: "storybook/instrumenter/end"
};

// src/instrumenter/preview-api.ts
var Kt = globalThis.__STORYBOOK_ADDONS_PREVIEW;

// src/instrumenter/types.ts
var Cp = /* @__PURE__ */ ((o) => (o.DONE = "done", o.ERROR = "error", o.ACTIVE = "active", o.WAITING = "waiting", o))(Cp || {});

// src/instrumenter/instrumenter.ts
var Ec = {
  start: !1,
  back: !1,
  goto: !1,
  next: !1,
  end: !1
}, Np = new Error(
  "This function ran after the play function completed. Did you forget to `await` it?"
), Ac = /* @__PURE__ */ i((e) => Object.prototype.toString.call(e) === "[object Object]", "isObject"), jp = /* @__PURE__ */ i((e) => Object.
prototype.toString.call(e) === "[object Module]", "isModule"), Mp = /* @__PURE__ */ i((e) => {
  if (!Ac(e) && !jp(e))
    return !1;
  if (e.constructor === void 0)
    return !0;
  let t = e.constructor.prototype;
  return !!Ac(t);
}, "isInstrumentable"), xp = /* @__PURE__ */ i((e) => {
  try {
    return new e.constructor();
  } catch {
    return {};
  }
}, "construct"), gn = /* @__PURE__ */ i(() => ({
  renderPhase: void 0,
  isDebugging: !1,
  isPlaying: !1,
  isLocked: !1,
  cursor: 0,
  calls: [],
  shadowCalls: [],
  callRefsByResult: /* @__PURE__ */ new Map(),
  chainedCallIds: /* @__PURE__ */ new Set(),
  ancestors: [],
  playUntil: void 0,
  resolvers: {},
  syncTimeout: void 0
}), "getInitialState"), Oc = /* @__PURE__ */ i((e, t = !1) => {
  let r = (t ? e.shadowCalls : e.calls).filter((o) => o.retain);
  if (!r.length)
    return;
  let n = new Map(
    Array.from(e.callRefsByResult.entries()).filter(([, o]) => o.retain)
  );
  return { cursor: r.length, calls: r, callRefsByResult: n };
}, "getRetainedState"), hn = class hn {
  constructor() {
    this.initialized = !1;
    this.state = V.window?.parent?.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ || {};
    let t = /* @__PURE__ */ i(({
      storyId: a,
      isPlaying: f = !0,
      isDebugging: y = !1
    }) => {
      let l = this.getState(a);
      this.setState(a, {
        ...gn(),
        ...Oc(l, y),
        shadowCalls: y ? l.shadowCalls : [],
        chainedCallIds: y ? l.chainedCallIds : /* @__PURE__ */ new Set(),
        playUntil: y ? l.playUntil : void 0,
        isPlaying: f,
        isDebugging: y
      }), this.sync(a);
    }, "resetState"), r = /* @__PURE__ */ i((a) => ({ storyId: f, playUntil: y }) => {
      this.getState(f).isDebugging || this.setState(f, ({ calls: h }) => ({
        calls: [],
        shadowCalls: h.map((g) => ({ ...g, status: "waiting" })),
        isDebugging: !0
      }));
      let l = this.getLog(f);
      this.setState(f, ({ shadowCalls: h }) => {
        if (y || !l.length)
          return { playUntil: y };
        let g = h.findIndex((m) => m.id === l[0].callId);
        return {
          playUntil: h.slice(0, g).filter((m) => m.interceptable && !m.ancestors?.length).slice(-1)[0]?.id
        };
      }), a.emit(Sc, { storyId: f, isDebugging: !0 });
    }, "start"), n = /* @__PURE__ */ i((a) => ({ storyId: f }) => {
      let y = this.getLog(f).filter((h) => !h.ancestors?.length), l = y.reduceRight((h, g, m) => h >= 0 || g.status === "waiting" ? h : m, -1);
      r(a)({ storyId: f, playUntil: y[l - 1]?.callId });
    }, "back"), o = /* @__PURE__ */ i((a) => ({ storyId: f, callId: y }) => {
      let { calls: l, shadowCalls: h, resolvers: g } = this.getState(f), m = l.find(({ id: d }) => d === y), p = h.find(({ id: d }) => d ===
      y);
      if (!m && p && Object.values(g).length > 0) {
        let d = this.getLog(f).find((S) => S.status === "waiting")?.callId;
        p.id !== d && this.setState(f, { playUntil: p.id }), Object.values(g).forEach((S) => S());
      } else
        r(a)({ storyId: f, playUntil: y });
    }, "goto"), s = /* @__PURE__ */ i((a) => ({ storyId: f }) => {
      let { resolvers: y } = this.getState(f);
      if (Object.values(y).length > 0)
        Object.values(y).forEach((l) => l());
      else {
        let l = this.getLog(f).find((h) => h.status === "waiting")?.callId;
        l ? r(a)({ storyId: f, playUntil: l }) : c({ storyId: f });
      }
    }, "next"), c = /* @__PURE__ */ i(({ storyId: a }) => {
      this.setState(a, { playUntil: void 0, isDebugging: !1 }), Object.values(this.getState(a).resolvers).forEach((f) => f());
    }, "end"), u = /* @__PURE__ */ i(({ storyId: a, newPhase: f }) => {
      let { isDebugging: y } = this.getState(a);
      this.setState(a, { renderPhase: f }), f === "preparing" && y && t({ storyId: a }), f === "playing" && t({ storyId: a, isDebugging: y }),
      f === "played" && this.setState(a, {
        isLocked: !1,
        isPlaying: !1,
        isDebugging: !1
      }), f === "errored" && this.setState(a, {
        isLocked: !1,
        isPlaying: !1
      });
    }, "renderPhaseChanged");
    Kt && Kt.ready().then(() => {
      this.channel = Kt.getChannel(), this.channel.on(Sc, t), this.channel.on(Ip, u), this.channel.on(Rp, () => {
        this.initialized ? this.cleanup() : this.initialized = !0;
      }), this.channel.on(ue.START, r(this.channel)), this.channel.on(ue.BACK, n(this.channel)), this.channel.on(ue.GOTO, o(this.channel)), this.
      channel.on(ue.NEXT, s(this.channel)), this.channel.on(ue.END, c);
    });
  }
  getState(t) {
    return this.state[t] || gn();
  }
  setState(t, r) {
    let n = this.getState(t), o = typeof r == "function" ? r(n) : r;
    this.state = { ...this.state, [t]: { ...n, ...o } }, V.window?.parent && (V.window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ =
    this.state);
  }
  cleanup() {
    this.state = Object.entries(this.state).reduce(
      (r, [n, o]) => {
        let s = Oc(o);
        return s && (r[n] = Object.assign(gn(), s)), r;
      },
      {}
    );
    let t = { controlStates: Ec, logItems: [] };
    this.channel?.emit(ue.SYNC, t), V.window?.parent && (V.window.parent.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER_STATE__ = this.state);
  }
  getLog(t) {
    let { calls: r, shadowCalls: n } = this.getState(t), o = [...n];
    r.forEach((c, u) => {
      o[u] = c;
    });
    let s = /* @__PURE__ */ new Set();
    return o.reduceRight((c, u) => (u.args.forEach((a) => {
      a?.__callId__ && s.add(a.__callId__);
    }), u.path.forEach((a) => {
      a.__callId__ && s.add(a.__callId__);
    }), (u.interceptable || u.exception) && !s.has(u.id) && (c.unshift({ callId: u.id, status: u.status, ancestors: u.ancestors }), s.add(u.
    id)), c), []);
  }
  // Traverses the object structure to recursively patch all function properties.
  // Returns the original object, or a new object with the same constructor,
  // depending on whether it should mutate.
  instrument(t, r, n = 0) {
    if (!Mp(t))
      return t;
    let { mutate: o = !1, path: s = [] } = r, c = r.getKeys ? r.getKeys(t, n) : Object.keys(t);
    return n += 1, c.reduce(
      (u, a) => {
        let f = Fp(t, a);
        if (typeof f?.get == "function") {
          if (f.configurable) {
            let l = /* @__PURE__ */ i(() => f?.get?.bind(t)?.(), "getter");
            Object.defineProperty(u, a, {
              get: /* @__PURE__ */ i(() => this.instrument(l(), { ...r, path: s.concat(a) }, n), "get")
            });
          }
          return u;
        }
        let y = t[a];
        return typeof y != "function" ? (u[a] = this.instrument(y, { ...r, path: s.concat(a) }, n), u) : "__originalFn__" in y && typeof y.__originalFn__ ==
        "function" ? (u[a] = y, u) : (u[a] = (...l) => this.track(a, y, t, l, r), u[a].__originalFn__ = y, Object.defineProperty(u[a], "name",
        { value: a, writable: !1 }), Object.keys(y).length > 0 && Object.assign(
          u[a],
          this.instrument({ ...y }, { ...r, path: s.concat(a) }, n)
        ), u);
      },
      o ? t : xp(t)
    );
  }
  // Monkey patch an object method to record calls.
  // Returns a function that invokes the original function, records the invocation ("call") and
  // returns the original result.
  track(t, r, n, o, s) {
    let c = o?.[0]?.__storyId__ || V.__STORYBOOK_PREVIEW__?.selectionStore?.selection?.storyId, { cursor: u, ancestors: a } = this.getState(
    c);
    this.setState(c, { cursor: u + 1 });
    let f = `${a.slice(-1)[0] || c} [${u}] ${t}`, { path: y = [], intercept: l = !1, retain: h = !1 } = s, g = typeof l == "function" ? l(t,
    y) : l, m = { id: f, cursor: u, storyId: c, ancestors: a, path: y, method: t, args: o, interceptable: g, retain: h }, d = (g && !a.length ?
    this.intercept : this.invoke).call(this, r, n, m, s);
    return this.instrument(d, { ...s, mutate: !0, path: [{ __callId__: m.id }] });
  }
  intercept(t, r, n, o) {
    let { chainedCallIds: s, isDebugging: c, playUntil: u } = this.getState(n.storyId), a = s.has(n.id);
    return !c || a || u ? (u === n.id && this.setState(n.storyId, { playUntil: void 0 }), this.invoke(t, r, n, o)) : new Promise((f) => {
      this.setState(n.storyId, ({ resolvers: y }) => ({
        isLocked: !1,
        resolvers: { ...y, [n.id]: f }
      }));
    }).then(() => (this.setState(n.storyId, (f) => {
      let { [n.id]: y, ...l } = f.resolvers;
      return { isLocked: !0, resolvers: l };
    }), this.invoke(t, r, n, o)));
  }
  invoke(t, r, n, o) {
    let { callRefsByResult: s, renderPhase: c } = this.getState(n.storyId), u = 25, a = /* @__PURE__ */ i((l, h, g) => {
      if (g.includes(l))
        return "[Circular]";
      if (g = [...g, l], h > u)
        return "...";
      if (s.has(l))
        return s.get(l);
      if (l instanceof Array)
        return l.map((m) => a(m, ++h, g));
      if (l instanceof Date)
        return { __date__: { value: l.toISOString() } };
      if (l instanceof Error) {
        let { name: m, message: p, stack: d } = l;
        return { __error__: { name: m, message: p, stack: d } };
      }
      if (l instanceof RegExp) {
        let { flags: m, source: p } = l;
        return { __regexp__: { flags: m, source: p } };
      }
      if (l instanceof V.window?.HTMLElement) {
        let { prefix: m, localName: p, id: d, classList: S, innerText: A } = l, T = Array.from(S);
        return { __element__: { prefix: m, localName: p, id: d, classNames: T, innerText: A } };
      }
      return typeof l == "function" ? {
        __function__: { name: "getMockName" in l ? l.getMockName() : l.name }
      } : typeof l == "symbol" ? { __symbol__: { description: l.description } } : typeof l == "object" && l?.constructor?.name && l?.constructor?.
      name !== "Object" ? { __class__: { name: l.constructor.name } } : Object.prototype.toString.call(l) === "[object Object]" ? Object.fromEntries(
        Object.entries(l).map(([m, p]) => [m, a(p, ++h, g)])
      ) : l;
    }, "serializeValues"), f = {
      ...n,
      args: n.args.map((l) => a(l, 0, []))
    };
    n.path.forEach((l) => {
      l?.__callId__ && this.setState(n.storyId, ({ chainedCallIds: h }) => ({
        chainedCallIds: new Set(Array.from(h).concat(l.__callId__))
      }));
    });
    let y = /* @__PURE__ */ i((l) => {
      if (l instanceof Error) {
        let { name: h, message: g, stack: m, callId: p = n.id } = l, {
          showDiff: d = void 0,
          diff: S = void 0,
          actual: A = void 0,
          expected: T = void 0
        } = l.name === "AssertionError" ? yn(l) : l, b = { name: h, message: g, stack: m, callId: p, showDiff: d, diff: S, actual: A, expected: T };
        if (this.update({ ...f, status: "error", exception: b }), this.setState(n.storyId, (E) => ({
          callRefsByResult: new Map([
            ...Array.from(E.callRefsByResult.entries()),
            [l, { __callId__: n.id, retain: n.retain }]
          ])
        })), n.ancestors?.length)
          throw Object.prototype.hasOwnProperty.call(l, "callId") || Object.defineProperty(l, "callId", { value: n.id }), l;
      }
      throw l;
    }, "handleException");
    try {
      if (c === "played" && !n.retain)
        throw Np;
      let h = (o.getArgs ? o.getArgs(n, this.getState(n.storyId)) : n.args).map((m) => typeof m != "function" || Lp(m) || Object.keys(m).length ?
      m : (...p) => {
        let { cursor: d, ancestors: S } = this.getState(n.storyId);
        this.setState(n.storyId, { cursor: 0, ancestors: [...S, n.id] });
        let A = /* @__PURE__ */ i(() => this.setState(n.storyId, { cursor: d, ancestors: S }), "restore"), T = !1;
        try {
          let b = m(...p);
          return b instanceof Promise ? (T = !0, b.finally(A)) : b;
        } finally {
          T || A();
        }
      }), g = t.apply(r, h);
      return g && ["object", "function", "symbol"].includes(typeof g) && this.setState(n.storyId, (m) => ({
        callRefsByResult: new Map([
          ...Array.from(m.callRefsByResult.entries()),
          [g, { __callId__: n.id, retain: n.retain }]
        ])
      })), this.update({
        ...f,
        status: g instanceof Promise ? "active" : "done"
      }), g instanceof Promise ? g.then((m) => (this.update({ ...f, status: "done" }), m), y) : g;
    } catch (l) {
      return y(l);
    }
  }
  // Sends the call info to the manager and synchronizes the log.
  update(t) {
    this.channel?.emit(ue.CALL, t), this.setState(t.storyId, ({ calls: r }) => {
      let n = r.concat(t).reduce((o, s) => Object.assign(o, { [s.id]: s }), {});
      return {
        // Calls are sorted to ensure parent calls always come before calls in their callback.
        calls: Object.values(n).sort(
          (o, s) => o.id.localeCompare(s.id, void 0, { numeric: !0 })
        )
      };
    }), this.sync(t.storyId);
  }
  // Builds a log of interceptable calls and control states and sends it to the manager.
  // Uses a 0ms debounce because this might get called many times in one tick.
  sync(t) {
    let r = /* @__PURE__ */ i(() => {
      let { isLocked: n, isPlaying: o } = this.getState(t), s = this.getLog(t), c = s.filter(({ ancestors: l }) => !l.length).find((l) => l.
      status === "waiting")?.callId, u = s.some((l) => l.status === "active");
      if (n || u || s.length === 0) {
        let l = { controlStates: Ec, logItems: s };
        this.channel?.emit(ue.SYNC, l);
        return;
      }
      let a = s.some(
        (l) => l.status === "done" || l.status === "error"
      ), y = { controlStates: {
        start: a,
        back: a,
        goto: !0,
        next: o,
        end: o
      }, logItems: s, pausedAt: c };
      this.channel?.emit(ue.SYNC, y);
    }, "synchronize");
    this.setState(t, ({ syncTimeout: n }) => (clearTimeout(n), { syncTimeout: setTimeout(r, 0) }));
  }
};
i(hn, "Instrumenter");
var mn = hn;
function vp(e, t = {}) {
  try {
    let r = !1, n = !1;
    return V.window?.location?.search?.includes("instrument=true") ? r = !0 : V.window?.location?.search?.includes("instrument=false") && (n =
    !0), V.window?.parent === V.window && !r || n ? e : (V.window && !V.window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__ && (V.window.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__ =
    new mn()), (V.window?.__STORYBOOK_ADDON_INTERACTIONS_INSTRUMENTER__).instrument(e, t));
  } catch (r) {
    return $p.warn(r), e;
  }
}
i(vp, "instrument");
function Fp(e, t) {
  let r = e;
  for (; r != null; ) {
    let n = Object.getOwnPropertyDescriptor(r, t);
    if (n)
      return n;
    r = Object.getPrototypeOf(r);
  }
}
i(Fp, "getPropertyDescriptor");
function Lp(e) {
  if (typeof e != "function")
    return !1;
  let t = Object.getOwnPropertyDescriptor(e, "prototype");
  return t ? !t.writable : !1;
}
i(Lp, "isClass");
export {
  Cp as CallStates,
  ue as EVENTS,
  vp as instrument
};
